// import React, { useEffect, useState } from "react";
// import { Modal } from "reactstrap";
// import "../../../assets/css/Sales/Proposal.css";

// import {
//   Document,
//   Page,
//   Image,
//   Text,
//   StyleSheet,
//   PDFDownloadLink,
//   PDFViewer,
//   View,
//   Font,
// } from "@react-pdf/renderer";
// import zithasLogo from "../../../assets/images/zithas-dark-logo.png";
// import JuliusSir from "../../../assets/images/julius.png";
// import advardSir from "../../../assets/images/edvard.png";
// import phasesImg from "../../../assets/images/development-phases.png";
// import serviceImg from "../../../assets/images/service-practice.png";
// import axios from "axios";
// import configure from "configure";
// import moment from "moment";
// import Loader from "pages/Separate/Loader";

// const MyProposalDocument = ({ loaction, proposalData }) => {
//   const ClientInfo = [
//     {
//       lable: "Company Name",
//       value:
//         proposalData?.companyname &&
//         proposalData?.companyname != "null" &&
//         proposalData?.companyname,
//     },
//     {
//       lable: "Contact Person",
//       value:
//         proposalData?.contactname &&
//         proposalData?.contactname != "null" &&
//         proposalData?.contactname,
//     },
//     {
//       lable: "Address",
//       value:
//         proposalData?.address &&
//         proposalData?.address != "null" &&
//         proposalData?.address,
//     },
//     {
//       lable: "Contact",
//       value:
//         proposalData?.cilentcontact &&
//         proposalData?.cilentcontact != "null" &&
//         proposalData?.cilentcontact,
//     },
//     {
//       lable: "Email id",
//       value:
//         proposalData?.email &&
//         proposalData?.email != "null" &&
//         proposalData?.email,
//     },
//     {
//       lable: "Website",
//       value:
//         proposalData?.website &&
//         proposalData?.website != "null" &&
//         proposalData?.website,
//     },
//   ];

//   const providerInfo = [
//     {
//       lable: "Company Name",
//       value:
//         proposalData?.company2 &&
//         proposalData?.company2 != "null" &&
//         proposalData?.company2,
//     },
//     {
//       lable: "Contact Person",
//       value:
//         proposalData?.contactmember &&
//         proposalData?.contactmember != "null" &&
//         proposalData?.contactmember,
//     },
//     {
//       lable: "Address",
//       value:
//         proposalData?.address1 &&
//         proposalData?.address1 != "null" &&
//         proposalData?.address1,
//     },
//     {
//       lable: "Contact",
//       value:
//         proposalData?.contact &&
//         proposalData?.contact != "null" &&
//         proposalData?.contact,
//     },
//     {
//       lable: "Email id",
//       value:
//         proposalData?.provideremail &&
//         proposalData?.provideremail != "null" &&
//         proposalData?.provideremail,
//     },
//     {
//       lable: "Website",
//       value:
//         proposalData?.website1 &&
//         proposalData?.website1 != "null" &&
//         proposalData?.website1,
//     },
//   ];

//   const testingDelivery = JSON.parse(
//     proposalData?.deliverytesting ? proposalData?.deliverytesting : "[]",
//   );

//   const termsAgreement = JSON.parse(
//     proposalData?.terms ? proposalData?.terms : "[]",
//   );

//   let costBreakDown = JSON.parse(
//     proposalData?.costbreakdown ? proposalData?.costbreakdown : "[]",
//   );

//   // costBreakDown = [...costBreakDown, ...costBreakDown, ...costBreakDown, ...costBreakDown, ...costBreakDown, ...costBreakDown, ...costBreakDown, ...costBreakDown]

//   // Font.register({
//   //   family: 'Noto Sans',
//   //   fonts: [
//   //     { src: 'https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,300;1,400;1,500;1,600;1,700;1,800&display=swap' },
//   //     // { src: 'https://fonts.gstatic.com' },
//   //     // { src: 'https://fonts.googleapis.com' }
//   //   ]
//   // })

//   Font.register({
//     family: "Noto Sans",
//     fonts: [
//       {
//         src: "https://fonts.boords.com/NotoSans-Regular.ttf",
//         fontWeight: "bold",
//       },
//     ],
//   });

//   const styles = StyleSheet.create({
//     body: {
//       paddingTop: 35,
//       paddingBottom: 45,
//       paddingHorizontal: 30,
//       position: "relative",
//       fontFamily: "Noto Sans",
//     },
//     topHeader: {
//       paddingBottom: "12px",
//       borderBottom: "2px solid purple",
//       textAlign: "center",
//       fontSize: "16px",
//       fontFamily: "Noto Sans",
//       fontWeight: "bold",
//     },
//     logo: {
//       width: 380,
//       marginVertical: 15,
//       marginLeft: 70,
//     },
//     header: {
//       fontSize: 25,
//       textAlign: "center",
//       margin: "25px 0",
//       fontWeight: "bold",
//     },
//     header2: {
//       fontSize: 17,
//       textAlign: "center",
//       margin: "30px 0 20px",
//       fontWeight: 600,
//     },
//     date: {
//       fontSize: 14,
//       textAlign: "center",
//       margin: "10px 0",
//       color: "#444",
//     },
//     table: {
//       display: "table",
//       width: "47%",
//       borderStyle: "solid",
//       borderWidth: 1,
//       borderColor: "#999",
//       borderRightWidth: 0,
//       borderBottomWidth: 0,
//       textAlign: "left !important",
//     },
//     tableRow: {
//       margin: "auto",
//       flexDirection: "row",
//     },
//     tableCol: {
//       width: "50%",
//       borderStyle: "solid",
//       borderWidth: 1,
//       borderColor: "#999",
//       borderLeftWidth: 0,
//       borderTopWidth: 0,
//     },
//     tableCell: {
//       margin: 5,
//       fontSize: 9,
//     },
//     tableBox: {
//       display: "flex",
//       flexDirection: "row",
//       justifyContent: "space-between",
//       marginTop: "40px",
//     },
//     paragraph: {
//       fontSize: "10px",
//       marginTop: "13px",
//       lineHeight: "1.5px",
//     },
//     footer: {
//       position: "absolute",
//       width: "100%",
//       bottom: "5%",
//       left: "5%",
//       fontSize: "12px",
//       textAlign: "center",
//     },
//     bottomLine: {
//       display: "flex",
//       flexDirection: "row",
//       height: "5px",
//       backgroundColor: "#999",
//       marginBottom: "7px",
//     },
//   });

//   const indexData = [
//     "INTRODUCTION",
//     "ABOUT ZITHAS",
//     "WEB DEVELOPMENT PROJECT DESCRIPTION",
//     "SERVICES PRACTICES",
//     "DELIVERABLES & TESTING",
//     "TERMS AND AGREEMENT",
//     "CONCLUSION",
//   ];

//   return (
//     <Document style={styles.body}>
//       <Page size="A4" orientation="80%" style={styles.body}>
//         <Image style={styles.logo} src={zithasLogo} />
//         <Text style={styles.header}>{proposalData?.proposaltitile}</Text>
//         <Text style={styles.header2}>{proposalData?.proposalsubtitle}</Text>
//         <Text style={styles.date}>
//           {moment(proposalData?.date).format("DD MMMM YYYY")}
//         </Text>

//         <View style={styles.tableBox}>
//           <View style={styles.table}>
//             <View style={styles.tableRow}>
//               <View
//                 style={{
//                   ...styles.tableCol,
//                   width: "100%",
//                   backgroundColor: "#333",
//                   color: "white",
//                   textAlign: "center",
//                 }}
//               >
//                 <Text style={styles.tableCell}>Client Infomation</Text>
//               </View>
//             </View>
//             {ClientInfo.map((client, i) => {
//               return (
//                 <View key={i} style={styles.tableRow}>
//                   <View
//                     style={{
//                       ...styles.tableCol,
//                       width: "40%",
//                       fontWeight: "bold",
//                     }}
//                   >
//                     <Text style={{ ...styles.tableCell }}>{client.lable}</Text>
//                   </View>
//                   <View
//                     style={{ ...styles.tableCol, width: "60%", color: "#666" }}
//                   >
//                     <Text style={styles.tableCell}>{client.value}</Text>
//                   </View>
//                 </View>
//               );
//             })}
//           </View>

//           <View style={styles.table}>
//             <View style={styles.tableRow}>
//               <View
//                 style={{
//                   ...styles.tableCol,
//                   width: "100%",
//                   backgroundColor: "#333",
//                   color: "white",
//                   textAlign: "center",
//                 }}
//               >
//                 <Text style={styles.tableCell}>Provider Infomation</Text>
//               </View>
//             </View>
//             {providerInfo.map((client, i) => {
//               return (
//                 <View key={i} style={styles.tableRow}>
//                   <View style={{ ...styles.tableCol, width: "40%" }}>
//                     <Text style={styles.tableCell}>{client.lable}</Text>
//                   </View>
//                   <View
//                     style={{ ...styles.tableCol, width: "60%", color: "#666" }}
//                   >
//                     <Text style={styles.tableCell}>{client.value}</Text>
//                   </View>
//                 </View>
//               );
//             })}
//           </View>
//         </View>

//         <Text style={{ ...styles.footer, fontSize: "10px", borderTop: "none" }}>
//           Zithas Technologies is pleased to submit a proposal for the and{" "}
//           {proposalData?.proposaltitile} to {proposalData?.companyname} This
//           proposal describes the technology,services terms, and schedule for the
//           project
//         </Text>
//       </Page>

//       <Page size="A4" style={styles.body}>
//         <View style={styles.topHeader}>
//           <Text>{proposalData?.proposaltitile}</Text>
//         </View>

//         <View style={{ marginTop: "30px" }}>
//           <View
//             style={{
//               textAlign: "center",
//               fontWeight: 900,
//               fontSize: "13px",
//               marginBottom: "14px",
//             }}
//           >
//             <Text>Table of Contents</Text>
//           </View>
//           {/* main Index */}
//           <View style={{ fontWeight: "600", textTransform: "capitalize" }}>
//             <View
//               style={{
//                 display: "flex",
//                 flexDirection: "row",
//                 alignItems: "center",
//                 justifyContent: "space-between",
//                 fontSize: "11px",
//                 marginBottom: "10px",
//               }}
//             >
//               <View style={{ display: "flex", flexDirection: "row" }}>
//                 <Text style={{ marginRight: "15px" }}>1</Text>
//                 <Text>Introduction</Text>
//               </View>
//               <Text style={{ margin: "0 4px" }}>
//                 ..............................................................................................................................................
//               </Text>
//               <Text>2</Text>
//             </View>
//             <View
//               style={{
//                 display: "flex",
//                 flexDirection: "row",
//                 alignItems: "center",
//                 justifyContent: "space-between",
//                 fontSize: "11px",
//                 marginBottom: "10px",
//               }}
//             >
//               <View style={{ display: "flex", flexDirection: "row" }}>
//                 <Text style={{ marginRight: "15px" }}>2</Text>
//                 <Text>About Zithas</Text>
//               </View>
//               <Text style={{ margin: "0 4px" }}>
//                 ................................................................................................................................................
//               </Text>
//               <Text>3</Text>
//             </View>
//             <View
//               style={{
//                 display: "flex",
//                 flexDirection: "row",
//                 alignItems: "center",
//                 justifyContent: "space-between",
//                 fontSize: "11px",
//                 marginBottom: "10px",
//               }}
//             >
//               <View style={{ display: "flex", flexDirection: "row" }}>
//                 <Text style={{ marginRight: "15px" }}>3</Text>
//                 <Text>Web Development Project Description</Text>
//               </View>
//               <Text style={{ margin: "0 4px" }}>
//                 .................................................................................................
//               </Text>
//               <Text>4</Text>
//             </View>
//             <View
//               style={{
//                 display: "flex",
//                 flexDirection: "row",
//                 alignItems: "center",
//                 justifyContent: "space-between",
//                 fontSize: "11px",
//                 marginBottom: "10px",
//               }}
//             >
//               <View style={{ display: "flex", flexDirection: "row" }}>
//                 <Text style={{ marginRight: "15px" }}>4</Text>
//                 <Text>Services Practices</Text>
//               </View>
//               <Text style={{ margin: "0 4px" }}>
//                 .......................................................................................................................................
//               </Text>
//               <Text>5</Text>
//             </View>
//             <View
//               style={{
//                 display: "flex",
//                 flexDirection: "row",
//                 alignItems: "center",
//                 justifyContent: "space-between",
//                 fontSize: "11px",
//                 marginBottom: "10px",
//               }}
//             >
//               <View style={{ display: "flex", flexDirection: "row" }}>
//                 <Text style={{ marginRight: "15px" }}>5</Text>
//                 <Text>Deliverables & Testing</Text>
//               </View>
//               <Text style={{ margin: "0 4px" }}>
//                 .............................................................................................................................
//               </Text>
//               <Text>6</Text>
//             </View>
//             <View
//               style={{
//                 display: "flex",
//                 flexDirection: "row",
//                 alignItems: "center",
//                 justifyContent: "space-between",
//                 fontSize: "11px",
//                 marginBottom: "10px",
//               }}
//             >
//               <View style={{ display: "flex", flexDirection: "row" }}>
//                 <Text style={{ marginRight: "15px" }}>6</Text>
//                 <Text>Terms and Agreement</Text>
//               </View>
//               <Text style={{ margin: "0 4px" }}>
//                 ................................................................................................................................
//               </Text>
//               <Text>7</Text>
//             </View>
//             <View
//               style={{
//                 display: "flex",
//                 flexDirection: "row",
//                 alignItems: "center",
//                 justifyContent: "space-between",
//                 fontSize: "11px",
//                 marginBottom: "10px",
//               }}
//             >
//               <View style={{ display: "flex", flexDirection: "row" }}>
//                 <Text style={{ marginRight: "15px" }}>7</Text>
//                 <Text>Conclusion</Text>
//               </View>
//               <Text style={{ margin: "0 4px" }}>
//                 ..................................................................................................................................................
//               </Text>
//               <Text
//                 render={({ pageNumber, totalPages }) => `${totalPages - 1}`}
//               ></Text>
//             </View>
//           </View>
//         </View>

//         <View style={styles.footer}>
//           <View style={styles.bottomLine}>
//             <View
//               style={{
//                 height: "100%",
//                 width: "35%",
//                 backgroundColor: "#850505",
//               }}
//             ></View>

//             <View
//               style={{
//                 height: "100%",
//                 width: "15%",
//                 backgroundColor: "#fea200",
//               }}
//             ></View>

//             <View
//               style={{
//                 height: "100%",
//                 width: "50%",
//                 backgroundColor: "#7cfe00",
//               }}
//             ></View>
//           </View>
//           <View
//             style={{
//               display: "flex",
//               flexDirection: "row",
//               justifyContent: "space-between",
//             }}
//           >
//             <Text>
//               © {new Date().getFullYear()}{" "}
//               {loaction == 1
//                 ? "Zithas Technologies Pvt. Ltd."
//                 : "Zithas Technologies Ltd."}
//             </Text>

//             <Text
//               render={({ pageNumber, totalPages }) =>
//                 `${pageNumber - 1} of ${totalPages - 1}`
//               }
//               fixed
//             ></Text>
//           </View>
//         </View>
//       </Page>

//       <Page size="A4" style={styles.body}>
//         <View style={styles.topHeader}>
//           <Text>{proposalData?.proposaltitile}</Text>
//         </View>

//         {/* main Contant */}
//         <View style={{ marginTop: "22px" }}>
//           <Text
//             style={{
//               color: "#7E5F00",
//               fontSize: "12px",
//               fontWeight: 800,
//               letterSpacing: "0.5px",
//               textTransform: "uppercase",
//               marginBottom: "10px",
//             }}
//           >
//             1. Introduction
//           </Text>

//           <Text style={styles.paragraph}>
//             This proposal describes the technology, services, terms, and
//             schedule for the Website development and Management System project.
//           </Text>

//           <Text style={styles.paragraph}>
//             In the digital age, the website frequently serves as your business
//             or organization’s front where you can manage the entire business
//             process and customers. Our mission is to give you a professional
//             on-line business process that will generally enhance your
//             organization productivity and management, as well as move prospects
//             through the sales process.
//           </Text>

//           <Text
//             style={{
//               ...styles.paragraph,
//               marginTop: "40px",
//               padding: 10,
//               backgroundColor: "#cccccc",
//             }}
//           >
//             Zithas Technologies (Hereafter known as the Provider) is pleased to
//             submit a proposal for the Software Development project of{" "}
//             {ClientInfo[0].value} (Hereafter known as the Client).
//           </Text>
//         </View>
//         {/* =============== */}

//         <View style={styles.footer}>
//           <View style={styles.bottomLine}>
//             <View
//               style={{
//                 height: "100%",
//                 width: "35%",
//                 backgroundColor: "#850505",
//               }}
//             ></View>

//             <View
//               style={{
//                 height: "100%",
//                 width: "15%",
//                 backgroundColor: "#fea200",
//               }}
//             ></View>

//             <View
//               style={{
//                 height: "100%",
//                 width: "50%",
//                 backgroundColor: "#7cfe00",
//               }}
//             ></View>
//           </View>
//           <View
//             style={{
//               display: "flex",
//               flexDirection: "row",
//               justifyContent: "space-between",
//             }}
//           >
//             <Text>
//               © {new Date().getFullYear()}{" "}
//               {loaction == 1
//                 ? "Zithas Technologies Pvt. Ltd."
//                 : "Zithas Technologies Ltd."}
//             </Text>

//             <Text
//               render={({ pageNumber, totalPages }) =>
//                 `${pageNumber - 1} of ${totalPages - 1}`
//               }
//               fixed
//             ></Text>
//           </View>
//         </View>
//       </Page>

//       <Page size="A4" style={styles.body}>
//         <View style={styles.topHeader}>
//           <Text>{proposalData?.proposaltitile}</Text>
//         </View>

//         {/* main Contant */}
//         <View style={{ marginTop: "22px" }}>
//           <Text
//             style={{
//               color: "#7E5F00",
//               fontSize: "12px",
//               fontWeight: 800,
//               letterSpacing: "0.5px",
//               textTransform: "uppercase",
//               marginBottom: "10px",
//             }}
//           >
//             2. ABOUT ZITHAS TECHNOLOGIES
//           </Text>

//           <Text style={styles.paragraph}>
//             Zithas Technologies is an IT service providing company with a group
//             of experts working under various fields to bring to you the most
//             appropriate solutions available to your requirements. We specialize
//             in the field of bespoke website design, CRM Development, ERP
//             development and other web solutions and services. We hold an
//             experience base of more than 12 years.
//           </Text>

//           <Text style={styles.paragraph}>
//             We assure you positive and clear results along with a completely
//             novel experience that will help your business expand its doors and
//             reach wider horizons.
//           </Text>

//           <Text
//             style={{ fontWeight: "900", marginTop: "20px", fontSize: "15px" }}
//           >
//             Our Vision is our Inspiration!
//           </Text>

//           <Text style={styles.paragraph}>
//             Assured quality and effective communication are the pillars we abide
//             to!
//           </Text>

//           <Text
//             style={{ fontWeight: "900", marginTop: "20px", fontSize: "19px" }}
//           >
//             From the Founder’s Desk!
//           </Text>

//           <Text style={styles.paragraph}>
//             Being the founders, the sole purpose under which we work is keeping
//             our clients happy and helping their business flourish. We run with
//             the motto “You Grow We Grow” and make sure that we get along our
//             clients expectations.
//           </Text>

//           <Text style={styles.paragraph}>
//             For us, Zithas is not just business, it is an opportunity to learn,
//             to develop and to achieve. It keeps us motivated and inspires us to
//             reach the top and be the best!
//           </Text>

//           <Text style={styles.paragraph}>
//             Understanding what our clients want and offering them what they
//             expect is the overriding purpose of our company. We aim to develop
//             and implement optimized strategies to provide more business
//             opportunities to our clients and help in actively engaging and
//             growing our client's business.
//           </Text>
//         </View>

//         <View
//           style={{
//             display: "flex",
//             flexDirection: "row",
//             alignItems: "center",
//             justifyContent: "space-evenly",
//           }}
//         >
//           {loaction == 1 ? (
//             <View
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 marginTop: "30px",
//               }}
//             >
//               <Image style={{ width: "150px" }} src={JuliusSir} />
//               <Text
//                 style={{
//                   fontWeight: "900",
//                   marginTop: "6px",
//                   fontSize: "10px",
//                 }}
//               >
//                 Julius Gohil
//               </Text>
//             </View>
//           ) : (
//             <>
//               <View
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   margin: "auto 12px",
//                   marginTop: "30px",
//                 }}
//               >
//                 <Image style={{ width: "150px" }} src={JuliusSir} />
//                 <Text
//                   style={{
//                     fontWeight: "900",
//                     marginTop: "6px",
//                     fontSize: "10px",
//                   }}
//                 >
//                   Julius Gohil
//                 </Text>
//               </View>
//               <View
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   margin: "0 12px",
//                   marginTop: "30px",
//                 }}
//               >
//                 <Image style={{ width: "150px" }} src={advardSir} />
//                 <Text
//                   style={{
//                     fontWeight: "900",
//                     marginTop: "6px",
//                     fontSize: "10px",
//                   }}
//                 >
//                   Edward Ball
//                 </Text>
//               </View>
//             </>
//           )}
//         </View>
//         {/* =============== */}

//         <View style={styles.footer}>
//           <View style={styles.bottomLine}>
//             <View
//               style={{
//                 height: "100%",
//                 width: "35%",
//                 backgroundColor: "#850505",
//               }}
//             ></View>

//             <View
//               style={{
//                 height: "100%",
//                 width: "15%",
//                 backgroundColor: "#fea200",
//               }}
//             ></View>

//             <View
//               style={{
//                 height: "100%",
//                 width: "50%",
//                 backgroundColor: "#7cfe00",
//               }}
//             ></View>
//           </View>
//           <View
//             style={{
//               display: "flex",
//               flexDirection: "row",
//               justifyContent: "space-between",
//             }}
//           >
//             <Text>
//               © {new Date().getFullYear()}{" "}
//               {loaction == 1
//                 ? "Zithas Technologies Pvt. Ltd."
//                 : "Zithas Technologies Ltd."}
//             </Text>

//             <Text
//               render={({ pageNumber, totalPages }) =>
//                 `${pageNumber - 1} of ${totalPages - 1}`
//               }
//               fixed
//             ></Text>
//           </View>
//         </View>
//       </Page>

//       <Page size="A4" style={styles.body}>
//         <View style={styles.topHeader}>
//           <Text>{proposalData?.proposaltitile}</Text>
//         </View>

//         {/* main Contant */}
//         <View style={{ marginTop: "22px" }}>
//           <Text
//             style={{
//               color: "#7E5F00",
//               fontSize: "12px",
//               fontWeight: 800,
//               letterSpacing: "0.5px",
//               textTransform: "uppercase",
//             }}
//           >
//             3. {proposalData?.proposaltitile} PROJECT DESCRIPTION
//           </Text>

//           <Text style={styles.paragraph}>
//             The proposed {proposalData?.proposaltitile} will take place in
//             several distinct phases: Strategy, Planning, Build, and Deploy
//           </Text>

//           <Text
//             style={{ fontWeight: "900", marginTop: "10px", fontSize: "13px" }}
//           >
//             Figure : Development Phases.
//           </Text>

//           <View style={{ marginTop: "10px" }}>
//             <Image style={{ width: "90%" }} src={phasesImg} />
//           </View>

//           <View>
//             <Text style={styles.paragraph}>
//               <Text
//                 style={{
//                   fontFamily: "Noto Sans",
//                   fontWeight: 900,
//                   textDecoration: "underline",
//                 }}
//               >
//                 1. Strategy :{" "}
//               </Text>
//               Phase, the scope, requirements, and description of the final
//               system will be determined and documented. It also includes the
//               overarching site goals, number of screens, app hierarchy,
//               merchandising needs, language and web tools to be used (i.e.
//               carts), plus forms, animations/graphics, and other specialized
//               content.
//             </Text>
//           </View>

//           <View>
//             <Text style={styles.paragraph}>
//               <Text
//                 style={{
//                   fontFamily: "Noto Sans",
//                   fontWeight: 900,
//                   textDecoration: "underline",
//                 }}
//               >
//                 2. Planning :{" "}
//               </Text>
//               In this phase, the sketches and/or page mock-ups that reflects the
//               general appearance of the system shall be created and submitted
//               for approval. Once approved, the system development will begin in
//               the next phase during which the client is responsible for
//               providing the content (text, images, audio files, video files,
//               etc.).
//             </Text>
//             {/* inner */}
//             <View style={{ marginLeft: "20px" }}>
//               <View>
//                 <Text style={styles.paragraph}>
//                   <Text
//                     style={{
//                       fontFamily: "Noto Sans",
//                       fontWeight: 900,
//                       textDecoration: "underline",
//                     }}
//                   >
//                     i. Creation and Coding :{" "}
//                   </Text>
//                   Screen are created in the previously determined language (PHP,
//                   HTML, CSS) to meet all the appearance, performance, and
//                   content requirements. These flow will be reviewed by the
//                   Client with appropriate feedback for revision
//                 </Text>
//               </View>

//               <View>
//                 <Text style={styles.paragraph}>
//                   <Text
//                     style={{
//                       fontFamily: "Noto Sans",
//                       fontWeight: 900,
//                       textDecoration: "underline",
//                     }}
//                   >
//                     ii. Revisions :{" "}
//                   </Text>
//                   Are revised in accordance with the review/feedback but within
//                   limit of scope.
//                 </Text>
//               </View>

//               <View>
//                 <Text style={styles.paragraph}>
//                   <Text
//                     style={{
//                       fontFamily: "Noto Sans",
//                       fontWeight: 900,
//                       textDecoration: "underline",
//                     }}
//                   >
//                     iii. Review and Testing :{" "}
//                   </Text>
//                   The finished Application will be reviewed and all functional
//                   aspects tested (i.e. forms, carts).
//                 </Text>
//               </View>
//             </View>
//           </View>

//           <View>
//             <Text style={styles.paragraph}>
//               <Text
//                 style={{
//                   fontFamily: "Noto Sans",
//                   fontWeight: 900,
//                   textDecoration: "underline",
//                 }}
//               >
//                 3. Build :{" "}
//               </Text>
//               In this phase, Creation &Coding, screen Revision, system Review
//               and Testing will be take place.
//             </Text>
//           </View>

//           <View>
//             <Text style={styles.paragraph}>
//               <Text
//                 style={{
//                   fontFamily: "Noto Sans",
//                   fontWeight: 900,
//                   textDecoration: "underline",
//                 }}
//               >
//                 4. Deploy :{" "}
//               </Text>
//               In this phase, the system will be uploaded and go live once the
//               review of all the revisions &modifications are completed. During
//               successful one-week period, all training materials will be
//               prepared (videos, manuals, guides, etc.). Once all the materials
//               and other details are transferred, the website project will be
//               considered complete.
//             </Text>
//           </View>
//         </View>
//         {/* =============== */}

//         <View style={styles.footer}>
//           <View style={styles.bottomLine}>
//             <View
//               style={{
//                 height: "100%",
//                 width: "35%",
//                 backgroundColor: "#850505",
//               }}
//             ></View>

//             <View
//               style={{
//                 height: "100%",
//                 width: "15%",
//                 backgroundColor: "#fea200",
//               }}
//             ></View>

//             <View
//               style={{
//                 height: "100%",
//                 width: "50%",
//                 backgroundColor: "#7cfe00",
//               }}
//             ></View>
//           </View>
//           <View
//             style={{
//               display: "flex",
//               flexDirection: "row",
//               justifyContent: "space-between",
//             }}
//           >
//             <Text>
//               © {new Date().getFullYear()}{" "}
//               {loaction == 1
//                 ? "Zithas Technologies Pvt. Ltd."
//                 : "Zithas Technologies Ltd."}
//             </Text>

//             <Text
//               render={({ pageNumber, totalPages }) =>
//                 `${pageNumber - 1} of ${totalPages}`
//               }
//               fixed
//             ></Text>
//           </View>
//         </View>
//       </Page>

//       <Page size="A4" style={styles.body}>
//         <View style={styles.topHeader}>
//           <Text>{proposalData?.proposaltitile}</Text>
//         </View>

//         {/* main Contant */}
//         <View style={{ marginTop: "22px" }}>
//           <Text
//             style={{
//               color: "#7E5F00",
//               fontSize: "12px",
//               fontWeight: 800,
//               letterSpacing: "0.5px",
//               textTransform: "uppercase",
//               marginBottom: "10px",
//             }}
//           >
//             4. SERVICES PRACTICES
//           </Text>

//           <View
//             style={{ display: "flex", alignItems: "center", marginTop: "20px" }}
//           >
//             <Image style={{ width: "80%" }} src={serviceImg} />
//           </View>

//           <Text
//             style={{
//               fontWeight: "900",
//               marginTop: "10px",
//               fontSize: "12px",
//               marginBottom: "20px",
//             }}
//           >
//             The {proposalData?.proposaltitile} project will be completed in the
//             following way:
//           </Text>

//           <Text style={styles.paragraph}>
//             1. The Provider will assign a project manager to oversee the project
//             and serve as a single point of for project communication. The
//             provider project team will also consist of additional developers and
//             other support staff members who will contribute as project
//             requirements dictate.
//           </Text>

//           <Text style={styles.paragraph}>
//             2. Project work will generally take place at the Provider
//             facilities, however the Provider project manager will coordinate
//             regular on-site visits on Client premises for meetings, evaluations,
//             observations, reviews, testing, and other project purposes as
//             needed.
//           </Text>

//           <Text style={styles.paragraph}>
//             3. All project work will be in accordance with accepted best
//             practices for {proposalData?.proposaltitile}.
//           </Text>

//           <Text style={styles.paragraph}>
//             4. Key requirements for the Software Development and management
//             system project will be established & documented in planning stage,
//             and it will be added as an Addendum to the Statement of Work.
//           </Text>

//           <Text
//             style={{ fontWeight: "900", marginTop: "30px", fontSize: "11px" }}
//           >
//             This proposal only covers {proposalData?.proposaltitile}. The
//             Provider will be happy to provide an on-going maintenance and
//             support proposal.
//           </Text>
//         </View>

//         <View style={styles.footer}>
//           <View style={styles.bottomLine}>
//             <View
//               style={{
//                 height: "100%",
//                 width: "35%",
//                 backgroundColor: "#850505",
//               }}
//             ></View>

//             <View
//               style={{
//                 height: "100%",
//                 width: "15%",
//                 backgroundColor: "#fea200",
//               }}
//             ></View>

//             <View
//               style={{
//                 height: "100%",
//                 width: "50%",
//                 backgroundColor: "#7cfe00",
//               }}
//             ></View>
//           </View>
//           <View
//             style={{
//               display: "flex",
//               flexDirection: "row",
//               justifyContent: "space-between",
//             }}
//           >
//             <Text>
//               © {new Date().getFullYear()}{" "}
//               {loaction == 1
//                 ? "Zithas Technologies Pvt. Ltd."
//                 : "Zithas Technologies Ltd."}
//             </Text>

//             <Text
//               render={({ pageNumber, totalPages }) =>
//                 `${pageNumber - 1} of ${totalPages - 1}`
//               }
//               fixed
//             ></Text>
//           </View>
//         </View>
//       </Page>

//       <Page size="A4" style={styles.body}>
//         <View style={styles.topHeader}>
//           <Text>{proposalData?.proposaltitile}</Text>
//         </View>

//         {/* main Contant */}
//         <View style={{ marginTop: "22px" }}>
//           <Text
//             style={{
//               color: "#7E5F00",
//               fontSize: "12px",
//               fontWeight: 800,
//               letterSpacing: "0.5px",
//               textTransform: "uppercase",
//               marginBottom: "10px",
//             }}
//           >
//             5. DELIVERABLES & TESTING
//           </Text>

//           <Text style={styles.paragraph}>
//             The Provider will deliver the following items during or at the
//             conclusion of the project:
//           </Text>

//           <Text style={{ fontSize: "10px", marginTop: "10px" }}>
//             1. Fully functional {proposalData?.proposaltitile}.
//           </Text>
//           <Text style={{ fontSize: "10px", marginTop: "5px" }}>
//             2. After project conclusion, an Email support service will be
//             provided.
//           </Text>

//           <Text style={styles.paragraph}>
//             The timeline for project milestones and deliverables is listed
//             below:
//           </Text>

//           {/* table */}
//           <View style={{ ...styles.table, width: "100%", marginTop: "20px" }}>
//             <View
//               style={{
//                 ...styles.tableRow,
//                 backgroundColor: "#d1b9d1",
//                 textTransform: "uppercase",
//                 color: "#6e276c",
//                 fontFamily: "Noto Sans",
//                 fontWeight: 900,
//               }}
//             >
//               <View
//                 style={{
//                   ...styles.tableCol,
//                   width: "10%",
//                   textAlign: "center",
//                 }}
//               >
//                 <Text style={styles.tableCell}>Sr. NO</Text>
//               </View>
//               <View style={{ ...styles.tableCol, width: "60%" }}>
//                 <Text style={styles.tableCell}>Milestone Description</Text>
//               </View>
//               <View
//                 style={{
//                   ...styles.tableCol,
//                   width: "30%",
//                   textAlign: "center",
//                 }}
//               >
//                 <Text style={styles.tableCell}>Estimated Time (In Weeks)</Text>
//               </View>
//             </View>
//             {testingDelivery.map((test, i) => {
//               return (
//                 <View
//                   key={i}
//                   style={{
//                     ...styles.tableRow,
//                     backgroundColor: i % 2 != 0 ? "#f3e7f7" : "",
//                   }}
//                 >
//                   <View
//                     style={{
//                       ...styles.tableCol,
//                       width: "10%",
//                       textAlign: "center",
//                     }}
//                   >
//                     <Text style={styles.tableCell}>{i + 1}</Text>
//                   </View>
//                   <View style={{ ...styles.tableCol, width: "60%" }}>
//                     <Text style={styles.tableCell}>{test.milestone}</Text>
//                   </View>
//                   <View
//                     style={{
//                       ...styles.tableCol,
//                       width: "30%",
//                       textAlign: "center",
//                     }}
//                   >
//                     <Text style={styles.tableCell}>{test.estimatedtime}</Text>
//                   </View>
//                 </View>
//               );
//             })}
//           </View>

//           <Text
//             style={{
//               ...styles.paragraph,
//               marginTop: "40px",
//               padding: 10,
//               backgroundColor: "#cccccc",
//             }}
//           >
//             <Text style={{ fontFamily: "Noto Sans", fontWeight: 900 }}>
//               Note :
//             </Text>
//             The estimated time may vary depending on the requirements of the
//             project.
//           </Text>
//         </View>
//         {/* =============== */}

//         <View style={styles.footer}>
//           <View style={styles.bottomLine}>
//             <View
//               style={{
//                 height: "100%",
//                 width: "35%",
//                 backgroundColor: "#850505",
//               }}
//             ></View>

//             <View
//               style={{
//                 height: "100%",
//                 width: "15%",
//                 backgroundColor: "#fea200",
//               }}
//             ></View>

//             <View
//               style={{
//                 height: "100%",
//                 width: "50%",
//                 backgroundColor: "#7cfe00",
//               }}
//             ></View>
//           </View>
//           <View
//             style={{
//               display: "flex",
//               flexDirection: "row",
//               justifyContent: "space-between",
//             }}
//           >
//             <Text>
//               © {new Date().getFullYear()}{" "}
//               {loaction == 1
//                 ? "Zithas Technologies Pvt. Ltd."
//                 : "Zithas Technologies Ltd."}
//             </Text>

//             <Text
//               render={({ pageNumber, totalPages }) =>
//                 `${pageNumber - 1} of ${totalPages - 1}`
//               }
//               fixed
//             ></Text>
//           </View>
//         </View>
//       </Page>

//       <Page size="A4" style={styles.body}>
//         <View style={styles.topHeader}>
//           <Text>{proposalData?.proposaltitile}</Text>
//         </View>

//         {/* main Contant */}

//         <View style={{ marginTop: "22px" }}>
//           <Text
//             style={{
//               color: "#7E5F00",
//               fontSize: "12px",
//               fontWeight: 800,
//               letterSpacing: "0.5px",
//               textTransform: "uppercase",
//               marginBottom: "10px",
//             }}
//           >
//             6. TERMS AND AGREEMENT
//           </Text>

//           <Text style={styles.paragraph}>
//             The terms for the {proposalData?.proposaltitile} project are defined
//             below:
//           </Text>

//           <Text
//             style={{
//               ...styles.paragraph,
//               fontSize: "12px",
//               fontFamily: "Noto Sans",
//               fontWeight: 900,
//             }}
//           >
//             Comprehensive {proposalData?.proposaltitile} Project:
//           </Text>

//           {/* table */}
//           <View
//             style={{
//               ...styles.table,
//               width: "100%",
//               marginTop: "20px",
//               borderWidth: 0,
//             }}
//           >
//             {termsAgreement.map((term, i) => {
//               return (
//                 <View style={{ ...styles.tableRow, borderWidth: 0 }} key={i}>
//                   <View
//                     style={{ ...styles.tableCol, width: "60%", borderWidth: 0 }}
//                   >
//                     <Text style={styles.tableCell}>{term.service}</Text>
//                   </View>
//                   <View
//                     style={{
//                       ...styles.tableCol,
//                       width: "20%",
//                       borderWidth: 0,
//                       textAlign: "right",
//                     }}
//                   >
//                     <Text style={styles.tableCell}> — </Text>
//                   </View>
//                   <View
//                     style={{
//                       ...styles.tableCol,
//                       width: "20%",
//                       borderWidth: 0,
//                       textAlign: "center",
//                     }}
//                   >
//                     <Text style={styles.tableCell}>
//                       {i == 0
//                         ? term.total
//                         : (proposalData?.currency == "₹"
//                             ? "Rs."
//                             : proposalData?.currency) +
//                           " " +
//                           term.total}
//                     </Text>
//                   </View>
//                 </View>
//               );
//             })}

//             {/* <View style={styles.tableRow}>
//               <View style={{ ...styles.tableCol, width: "70%" }}>
//                 <Text style={styles.tableCell}>{"Zithas Mars - Payroll Management"}</Text>
//               </View>
//               <View style={{ ...styles.tableCol, width: "30%", textAlign: "center" }}>
//                 <Text style={styles.tableCell}>{"10000"}</Text>
//               </View>
//             </View>

//             <View style={styles.tableRow}>
//               <View style={{ ...styles.tableCol, width: "70%" }}>
//                 <Text style={styles.tableCell}>{"Domain, Hosting, And SSL (Annual Charges)"}</Text>
//               </View>
//               <View style={{ ...styles.tableCol, width: "30%", textAlign: "center" }}>
//                 <Text style={styles.tableCell}>{"20000"}</Text>
//               </View>
//             </View> */}
//           </View>
//         </View>

//         {/* =============== */}

//         <View style={styles.footer}>
//           <View style={styles.bottomLine}>
//             <View
//               style={{
//                 height: "100%",
//                 width: "35%",
//                 backgroundColor: "#850505",
//               }}
//             ></View>

//             <View
//               style={{
//                 height: "100%",
//                 width: "15%",
//                 backgroundColor: "#fea200",
//               }}
//             ></View>

//             <View
//               style={{
//                 height: "100%",
//                 width: "50%",
//                 backgroundColor: "#7cfe00",
//               }}
//             ></View>
//           </View>
//           <View
//             style={{
//               display: "flex",
//               flexDirection: "row",
//               justifyContent: "space-between",
//             }}
//           >
//             <Text>
//               © {new Date().getFullYear()}{" "}
//               {loaction == 1
//                 ? "Zithas Technologies Pvt. Ltd."
//                 : "Zithas Technologies Ltd."}
//             </Text>

//             <Text
//               render={({ pageNumber, totalPages }) =>
//                 `${pageNumber - 1} of ${totalPages - 1}`
//               }
//               fixed
//             ></Text>
//           </View>
//         </View>
//       </Page>

//       {/* cost breakdown ========================================= */}
//       <Page size="A4" style={styles.body}>
//         <View style={styles.topHeader}>
//           <Text>{proposalData?.proposaltitile}</Text>
//         </View>

//         {/* main Contant */}
//         <View style={{ marginTop: "22px" }}>
//           <Text
//             style={{
//               color: "#7E5F00",
//               fontSize: "12px",
//               fontWeight: 800,
//               letterSpacing: "0.5px",
//               textTransform: "uppercase",
//               marginBottom: "10px",
//             }}
//           >
//             PROJECT COST BREAK-DOWN:
//           </Text>

//           {/* table */}
//           <View style={{ ...styles.table, width: "100%", marginTop: "20px" }}>
//             <View
//               style={{
//                 ...styles.tableRow,
//                 backgroundColor: "#d1b9d1",
//                 textTransform: "uppercase",
//                 color: "#6e276c",
//                 fontFamily: "Noto Sans",
//                 fontWeight: 900,
//               }}
//             >
//               <View
//                 style={{
//                   ...styles.tableCol,
//                   width: "10%",
//                   textAlign: "center",
//                 }}
//               >
//                 <Text style={styles.tableCell}>Sr. NO</Text>
//               </View>
//               <View style={{ ...styles.tableCol, width: "60%" }}>
//                 <Text style={styles.tableCell}> Description</Text>
//               </View>
//               <View
//                 style={{
//                   ...styles.tableCol,
//                   width: "30%",
//                   textAlign: "center",
//                 }}
//               >
//                 <Text style={styles.tableCell}>TOTAL COST</Text>
//               </View>
//             </View>
//             {costBreakDown.slice(0, 19).map((test, i) => {
//               return (
//                 <View
//                   key={i}
//                   style={{
//                     ...styles.tableRow,
//                     backgroundColor: i % 2 != 0 ? "#f3e7f7" : "",
//                   }}
//                 >
//                   <View
//                     style={{
//                       ...styles.tableCol,
//                       width: "10%",
//                       textAlign: "center",
//                     }}
//                   >
//                     <Text style={styles.tableCell}>
//                       {test.sr_no && test.sr_no}
//                     </Text>
//                   </View>
//                   <View
//                     style={{
//                       ...styles.tableCol,
//                       width: "60%",
//                       color: test.sr_no ? "black" : "#777",
//                     }}
//                   >
//                     <Text style={styles.tableCell}>{test.description}</Text>
//                   </View>
//                   <View
//                     style={{
//                       ...styles.tableCol,
//                       width: "30%",
//                       textAlign: "center",
//                     }}
//                   >
//                     <Text style={styles.tableCell}>
//                       {test.totalcost &&
//                         (proposalData?.currency == "₹"
//                           ? "Rs."
//                           : proposalData?.currency) +
//                           " " +
//                           test.totalcost}
//                     </Text>
//                   </View>
//                 </View>
//               );
//             })}
//           </View>
//         </View>
//         {/* =============== */}

//         <View style={styles.footer}>
//           <View style={styles.bottomLine}>
//             <View
//               style={{
//                 height: "100%",
//                 width: "35%",
//                 backgroundColor: "#850505",
//               }}
//             ></View>

//             <View
//               style={{
//                 height: "100%",
//                 width: "15%",
//                 backgroundColor: "#fea200",
//               }}
//             ></View>

//             <View
//               style={{
//                 height: "100%",
//                 width: "50%",
//                 backgroundColor: "#7cfe00",
//               }}
//             ></View>
//           </View>
//           <View
//             style={{
//               display: "flex",
//               flexDirection: "row",
//               justifyContent: "space-between",
//             }}
//           >
//             <Text>
//               © {new Date().getFullYear()}{" "}
//               {loaction == 1
//                 ? "Zithas Technologies Pvt. Ltd."
//                 : "Zithas Technologies Ltd."}
//             </Text>

//             <Text
//               render={({ pageNumber, totalPages }) =>
//                 `${pageNumber - 1} of ${totalPages - 1}`
//               }
//               fixed
//             ></Text>
//           </View>
//         </View>
//       </Page>

//       {costBreakDown.length > 19 && (
//         <Page size="A4" style={styles.body}>
//           <View style={styles.topHeader}>
//             <Text>{proposalData?.proposaltitile}</Text>
//           </View>

//           {/* main Contant */}
//           <View style={{ marginTop: "10px" }}>
//             {/* table */}
//             <View style={{ ...styles.table, width: "100%", marginTop: "20px" }}>
//               <View
//                 style={{
//                   ...styles.tableRow,
//                   backgroundColor: "#d1b9d1",
//                   textTransform: "uppercase",
//                   color: "#6e276c",
//                   fontFamily: "Noto Sans",
//                   fontWeight: 900,
//                 }}
//               >
//                 <View
//                   style={{
//                     ...styles.tableCol,
//                     width: "10%",
//                     textAlign: "center",
//                   }}
//                 >
//                   <Text style={styles.tableCell}>Sr. NO</Text>
//                 </View>
//                 <View style={{ ...styles.tableCol, width: "60%" }}>
//                   <Text style={styles.tableCell}> Description</Text>
//                 </View>
//                 <View
//                   style={{
//                     ...styles.tableCol,
//                     width: "30%",
//                     textAlign: "center",
//                   }}
//                 >
//                   <Text style={styles.tableCell}>TOTAL COST</Text>
//                 </View>
//               </View>
//               {costBreakDown.slice(19, 38).map((test, i) => {
//                 return (
//                   <View
//                     key={i}
//                     style={{
//                       ...styles.tableRow,
//                       backgroundColor: i % 2 != 0 ? "#f3e7f7" : "",
//                     }}
//                   >
//                     <View
//                       style={{
//                         ...styles.tableCol,
//                         width: "10%",
//                         textAlign: "center",
//                       }}
//                     >
//                       <Text style={styles.tableCell}>
//                         {test.sr_no && test.sr_no}
//                       </Text>
//                     </View>
//                     <View
//                       style={{
//                         ...styles.tableCol,
//                         width: "60%",
//                         color: test.sr_no ? "black" : "#777",
//                       }}
//                     >
//                       <Text style={styles.tableCell}>{test.description}</Text>
//                     </View>
//                     <View
//                       style={{
//                         ...styles.tableCol,
//                         width: "30%",
//                         textAlign: "center",
//                       }}
//                     >
//                       <Text style={styles.tableCell}>
//                         {test.totalcost &&
//                           (proposalData?.currency == "₹"
//                             ? "Rs."
//                             : proposalData?.currency) +
//                             " " +
//                             test.totalcost}
//                       </Text>
//                     </View>
//                   </View>
//                 );
//               })}
//             </View>
//           </View>
//           {/* =============== */}

//           <View style={styles.footer}>
//             <View style={styles.bottomLine}>
//               <View
//                 style={{
//                   height: "100%",
//                   width: "35%",
//                   backgroundColor: "#850505",
//                 }}
//               ></View>

//               <View
//                 style={{
//                   height: "100%",
//                   width: "15%",
//                   backgroundColor: "#fea200",
//                 }}
//               ></View>

//               <View
//                 style={{
//                   height: "100%",
//                   width: "50%",
//                   backgroundColor: "#7cfe00",
//                 }}
//               ></View>
//             </View>
//             <View
//               style={{
//                 display: "flex",
//                 flexDirection: "row",
//                 justifyContent: "space-between",
//               }}
//             >
//               <Text>
//                 © {new Date().getFullYear()}{" "}
//                 {loaction == 1
//                   ? "Zithas Technologies Pvt. Ltd."
//                   : "Zithas Technologies Ltd."}
//               </Text>

//               <Text
//                 render={({ pageNumber, totalPages }) =>
//                   `${pageNumber - 1} of ${totalPages - 1}`
//                 }
//                 fixed
//               ></Text>
//             </View>
//           </View>
//         </Page>
//       )}

//       {costBreakDown.length > 38 && (
//         <Page size="A4" style={styles.body}>
//           <View style={styles.topHeader}>
//             <Text>{proposalData?.proposaltitile}</Text>
//           </View>

//           {/* main Contant */}
//           <View style={{ marginTop: "10px" }}>
//             {/* table */}
//             <View style={{ ...styles.table, width: "100%", marginTop: "20px" }}>
//               <View
//                 style={{
//                   ...styles.tableRow,
//                   backgroundColor: "#d1b9d1",
//                   textTransform: "uppercase",
//                   color: "#6e276c",
//                   fontFamily: "Noto Sans",
//                   fontWeight: 900,
//                 }}
//               >
//                 <View
//                   style={{
//                     ...styles.tableCol,
//                     width: "10%",
//                     textAlign: "center",
//                   }}
//                 >
//                   <Text style={styles.tableCell}>Sr. NO</Text>
//                 </View>
//                 <View style={{ ...styles.tableCol, width: "60%" }}>
//                   <Text style={styles.tableCell}> Description</Text>
//                 </View>
//                 <View
//                   style={{
//                     ...styles.tableCol,
//                     width: "30%",
//                     textAlign: "center",
//                   }}
//                 >
//                   <Text style={styles.tableCell}>TOTAL COST</Text>
//                 </View>
//               </View>
//               {costBreakDown.slice(38, 57).map((test, i) => {
//                 return (
//                   <View
//                     key={i}
//                     style={{
//                       ...styles.tableRow,
//                       backgroundColor: i % 2 != 0 ? "#f3e7f7" : "",
//                     }}
//                   >
//                     <View
//                       style={{
//                         ...styles.tableCol,
//                         width: "10%",
//                         textAlign: "center",
//                       }}
//                     >
//                       <Text style={styles.tableCell}>
//                         {test.sr_no && test.sr_no}
//                       </Text>
//                     </View>
//                     <View
//                       style={{
//                         ...styles.tableCol,
//                         width: "60%",
//                         color: test.sr_no ? "black" : "#777",
//                       }}
//                     >
//                       <Text style={styles.tableCell}>{test.description}</Text>
//                     </View>
//                     <View
//                       style={{
//                         ...styles.tableCol,
//                         width: "30%",
//                         textAlign: "center",
//                       }}
//                     >
//                       <Text style={styles.tableCell}>
//                         {test.totalcost &&
//                           (proposalData?.currency == "₹"
//                             ? "Rs."
//                             : proposalData?.currency) +
//                             " " +
//                             test.totalcost}
//                       </Text>
//                     </View>
//                   </View>
//                 );
//               })}
//             </View>
//           </View>
//           {/* =============== */}

//           <View style={styles.footer}>
//             <View style={styles.bottomLine}>
//               <View
//                 style={{
//                   height: "100%",
//                   width: "35%",
//                   backgroundColor: "#850505",
//                 }}
//               ></View>

//               <View
//                 style={{
//                   height: "100%",
//                   width: "15%",
//                   backgroundColor: "#fea200",
//                 }}
//               ></View>

//               <View
//                 style={{
//                   height: "100%",
//                   width: "50%",
//                   backgroundColor: "#7cfe00",
//                 }}
//               ></View>
//             </View>
//             <View
//               style={{
//                 display: "flex",
//                 flexDirection: "row",
//                 justifyContent: "space-between",
//               }}
//             >
//               <Text>
//                 © {new Date().getFullYear()}{" "}
//                 {loaction == 1
//                   ? "Zithas Technologies Pvt. Ltd."
//                   : "Zithas Technologies Ltd."}
//               </Text>

//               <Text
//                 render={({ pageNumber, totalPages }) =>
//                   `${pageNumber - 1} of ${totalPages - 1}`
//                 }
//                 fixed
//               ></Text>
//             </View>
//           </View>
//         </Page>
//       )}

//       {costBreakDown.length > 57 && (
//         <Page size="A4" style={styles.body}>
//           <View style={styles.topHeader}>
//             <Text>{proposalData?.proposaltitile}</Text>
//           </View>

//           {/* main Contant */}
//           <View style={{ marginTop: "10px" }}>
//             {/* table */}
//             <View style={{ ...styles.table, width: "100%", marginTop: "20px" }}>
//               <View
//                 style={{
//                   ...styles.tableRow,
//                   backgroundColor: "#d1b9d1",
//                   textTransform: "uppercase",
//                   color: "#6e276c",
//                   fontFamily: "Noto Sans",
//                   fontWeight: 900,
//                 }}
//               >
//                 <View
//                   style={{
//                     ...styles.tableCol,
//                     width: "10%",
//                     textAlign: "center",
//                   }}
//                 >
//                   <Text style={styles.tableCell}>Sr. NO</Text>
//                 </View>
//                 <View style={{ ...styles.tableCol, width: "60%" }}>
//                   <Text style={styles.tableCell}> Description</Text>
//                 </View>
//                 <View
//                   style={{
//                     ...styles.tableCol,
//                     width: "30%",
//                     textAlign: "center",
//                   }}
//                 >
//                   <Text style={styles.tableCell}>TOTAL COST</Text>
//                 </View>
//               </View>
//               {costBreakDown.slice(57, 76).map((test, i) => {
//                 return (
//                   <View
//                     key={i}
//                     style={{
//                       ...styles.tableRow,
//                       backgroundColor: i % 2 != 0 ? "#f3e7f7" : "",
//                     }}
//                   >
//                     <View
//                       style={{
//                         ...styles.tableCol,
//                         width: "10%",
//                         textAlign: "center",
//                       }}
//                     >
//                       <Text style={styles.tableCell}>
//                         {test.sr_no && test.sr_no}
//                       </Text>
//                     </View>
//                     <View
//                       style={{
//                         ...styles.tableCol,
//                         width: "60%",
//                         color: test.sr_no ? "black" : "#777",
//                       }}
//                     >
//                       <Text style={styles.tableCell}>{test.description}</Text>
//                     </View>
//                     <View
//                       style={{
//                         ...styles.tableCol,
//                         width: "30%",
//                         textAlign: "center",
//                       }}
//                     >
//                       <Text style={styles.tableCell}>
//                         {test.totalcost &&
//                           (proposalData?.currency == "₹"
//                             ? "Rs."
//                             : proposalData?.currency) +
//                             " " +
//                             test.totalcost}
//                       </Text>
//                     </View>
//                   </View>
//                 );
//               })}
//             </View>
//           </View>
//           {/* =============== */}

//           <View style={styles.footer}>
//             <View style={styles.bottomLine}>
//               <View
//                 style={{
//                   height: "100%",
//                   width: "35%",
//                   backgroundColor: "#850505",
//                 }}
//               ></View>

//               <View
//                 style={{
//                   height: "100%",
//                   width: "15%",
//                   backgroundColor: "#fea200",
//                 }}
//               ></View>

//               <View
//                 style={{
//                   height: "100%",
//                   width: "50%",
//                   backgroundColor: "#7cfe00",
//                 }}
//               ></View>
//             </View>
//             <View
//               style={{
//                 display: "flex",
//                 flexDirection: "row",
//                 justifyContent: "space-between",
//               }}
//             >
//               <Text>
//                 © {new Date().getFullYear()}{" "}
//                 {loaction == 1
//                   ? "Zithas Technologies Pvt. Ltd."
//                   : "Zithas Technologies Ltd."}
//               </Text>

//               <Text
//                 render={({ pageNumber, totalPages }) =>
//                   `${pageNumber - 1} of ${totalPages - 1}`
//                 }
//                 fixed
//               ></Text>
//             </View>
//           </View>
//         </Page>
//       )}

//       {costBreakDown.length > 76 && (
//         <Page size="A4" style={styles.body}>
//           <View style={styles.topHeader}>
//             <Text>{proposalData?.proposaltitile}</Text>
//           </View>

//           {/* main Contant */}
//           <View style={{ marginTop: "10px" }}>
//             {/* table */}
//             <View style={{ ...styles.table, width: "100%", marginTop: "20px" }}>
//               <View
//                 style={{
//                   ...styles.tableRow,
//                   backgroundColor: "#d1b9d1",
//                   textTransform: "uppercase",
//                   color: "#6e276c",
//                   fontFamily: "Noto Sans",
//                   fontWeight: 900,
//                 }}
//               >
//                 <View
//                   style={{
//                     ...styles.tableCol,
//                     width: "10%",
//                     textAlign: "center",
//                   }}
//                 >
//                   <Text style={styles.tableCell}>Sr. NO</Text>
//                 </View>
//                 <View style={{ ...styles.tableCol, width: "60%" }}>
//                   <Text style={styles.tableCell}> Description</Text>
//                 </View>
//                 <View
//                   style={{
//                     ...styles.tableCol,
//                     width: "30%",
//                     textAlign: "center",
//                   }}
//                 >
//                   <Text style={styles.tableCell}>TOTAL COST</Text>
//                 </View>
//               </View>
//               {costBreakDown.slice(76, 95).map((test, i) => {
//                 return (
//                   <View
//                     key={i}
//                     style={{
//                       ...styles.tableRow,
//                       backgroundColor: i % 2 != 0 ? "#f3e7f7" : "",
//                     }}
//                   >
//                     <View
//                       style={{
//                         ...styles.tableCol,
//                         width: "10%",
//                         textAlign: "center",
//                       }}
//                     >
//                       <Text style={styles.tableCell}>
//                         {test.sr_no && test.sr_no}
//                       </Text>
//                     </View>
//                     <View
//                       style={{
//                         ...styles.tableCol,
//                         width: "60%",
//                         color: test.sr_no ? "black" : "#777",
//                       }}
//                     >
//                       <Text style={styles.tableCell}>{test.description}</Text>
//                     </View>
//                     <View
//                       style={{
//                         ...styles.tableCol,
//                         width: "30%",
//                         textAlign: "center",
//                       }}
//                     >
//                       <Text style={styles.tableCell}>
//                         {test.totalcost &&
//                           (proposalData?.currency == "₹"
//                             ? "Rs."
//                             : proposalData?.currency) +
//                             " " +
//                             test.totalcost}
//                       </Text>
//                     </View>
//                   </View>
//                 );
//               })}
//             </View>
//           </View>
//           {/* =============== */}

//           <View style={styles.footer}>
//             <View style={styles.bottomLine}>
//               <View
//                 style={{
//                   height: "100%",
//                   width: "35%",
//                   backgroundColor: "#850505",
//                 }}
//               ></View>

//               <View
//                 style={{
//                   height: "100%",
//                   width: "15%",
//                   backgroundColor: "#fea200",
//                 }}
//               ></View>

//               <View
//                 style={{
//                   height: "100%",
//                   width: "50%",
//                   backgroundColor: "#7cfe00",
//                 }}
//               ></View>
//             </View>
//             <View
//               style={{
//                 display: "flex",
//                 flexDirection: "row",
//                 justifyContent: "space-between",
//               }}
//             >
//               <Text>
//                 © {new Date().getFullYear()}{" "}
//                 {loaction == 1
//                   ? "Zithas Technologies Pvt. Ltd."
//                   : "Zithas Technologies Ltd."}
//               </Text>

//               <Text
//                 render={({ pageNumber, totalPages }) =>
//                   `${pageNumber - 1} of ${totalPages - 1}`
//                 }
//                 fixed
//               ></Text>
//             </View>
//           </View>
//         </Page>
//       )}

//       {costBreakDown.length > 95 && (
//         <Page size="A4" style={styles.body}>
//           <View style={styles.topHeader}>
//             <Text>{proposalData?.proposaltitile}</Text>
//           </View>

//           {/* main Contant */}
//           <View style={{ marginTop: "10px" }}>
//             {/* table */}
//             <View style={{ ...styles.table, width: "100%", marginTop: "20px" }}>
//               <View
//                 style={{
//                   ...styles.tableRow,
//                   backgroundColor: "#d1b9d1",
//                   textTransform: "uppercase",
//                   color: "#6e276c",
//                   fontFamily: "Noto Sans",
//                   fontWeight: 900,
//                 }}
//               >
//                 <View
//                   style={{
//                     ...styles.tableCol,
//                     width: "10%",
//                     textAlign: "center",
//                   }}
//                 >
//                   <Text style={styles.tableCell}>Sr. NO</Text>
//                 </View>
//                 <View style={{ ...styles.tableCol, width: "60%" }}>
//                   <Text style={styles.tableCell}> Description</Text>
//                 </View>
//                 <View
//                   style={{
//                     ...styles.tableCol,
//                     width: "30%",
//                     textAlign: "center",
//                   }}
//                 >
//                   <Text style={styles.tableCell}>TOTAL COST</Text>
//                 </View>
//               </View>
//               {costBreakDown.slice(95, 114).map((test, i) => {
//                 return (
//                   <View
//                     key={i}
//                     style={{
//                       ...styles.tableRow,
//                       backgroundColor: i % 2 != 0 ? "#f3e7f7" : "",
//                     }}
//                   >
//                     <View
//                       style={{
//                         ...styles.tableCol,
//                         width: "10%",
//                         textAlign: "center",
//                       }}
//                     >
//                       <Text style={styles.tableCell}>
//                         {test.sr_no && test.sr_no}
//                       </Text>
//                     </View>
//                     <View
//                       style={{
//                         ...styles.tableCol,
//                         width: "60%",
//                         color: test.sr_no ? "black" : "#777",
//                       }}
//                     >
//                       <Text style={styles.tableCell}>{test.description}</Text>
//                     </View>
//                     <View
//                       style={{
//                         ...styles.tableCol,
//                         width: "30%",
//                         textAlign: "center",
//                       }}
//                     >
//                       <Text style={styles.tableCell}>
//                         {test.totalcost &&
//                           (proposalData?.currency == "₹"
//                             ? "Rs."
//                             : proposalData?.currency) +
//                             " " +
//                             test.totalcost}
//                       </Text>
//                     </View>
//                   </View>
//                 );
//               })}
//             </View>
//           </View>
//           {/* =============== */}

//           <View style={styles.footer}>
//             <View style={styles.bottomLine}>
//               <View
//                 style={{
//                   height: "100%",
//                   width: "35%",
//                   backgroundColor: "#850505",
//                 }}
//               ></View>

//               <View
//                 style={{
//                   height: "100%",
//                   width: "15%",
//                   backgroundColor: "#fea200",
//                 }}
//               ></View>

//               <View
//                 style={{
//                   height: "100%",
//                   width: "50%",
//                   backgroundColor: "#7cfe00",
//                 }}
//               ></View>
//             </View>
//             <View
//               style={{
//                 display: "flex",
//                 flexDirection: "row",
//                 justifyContent: "space-between",
//               }}
//             >
//               <Text>
//                 © {new Date().getFullYear()}{" "}
//                 {loaction == 1
//                   ? "Zithas Technologies Pvt. Ltd."
//                   : "Zithas Technologies Ltd."}
//               </Text>

//               <Text
//                 render={({ pageNumber, totalPages }) =>
//                   `${pageNumber - 1} of ${totalPages - 1}`
//                 }
//                 fixed
//               ></Text>
//             </View>
//           </View>
//         </Page>
//       )}

//       {costBreakDown.length > 114 && (
//         <Page size="A4" style={styles.body}>
//           <View style={styles.topHeader}>
//             <Text>{proposalData?.proposaltitile}</Text>
//           </View>

//           {/* main Contant */}
//           <View style={{ marginTop: "10px" }}>
//             {/* table */}
//             <View style={{ ...styles.table, width: "100%", marginTop: "20px" }}>
//               <View
//                 style={{
//                   ...styles.tableRow,
//                   backgroundColor: "#d1b9d1",
//                   textTransform: "uppercase",
//                   color: "#6e276c",
//                   fontFamily: "Noto Sans",
//                   fontWeight: 900,
//                 }}
//               >
//                 <View
//                   style={{
//                     ...styles.tableCol,
//                     width: "10%",
//                     textAlign: "center",
//                   }}
//                 >
//                   <Text style={styles.tableCell}>Sr. NO</Text>
//                 </View>
//                 <View style={{ ...styles.tableCol, width: "60%" }}>
//                   <Text style={styles.tableCell}> Description</Text>
//                 </View>
//                 <View
//                   style={{
//                     ...styles.tableCol,
//                     width: "30%",
//                     textAlign: "center",
//                   }}
//                 >
//                   <Text style={styles.tableCell}>TOTAL COST</Text>
//                 </View>
//               </View>
//               {costBreakDown.slice(114, 133).map((test, i) => {
//                 return (
//                   <View
//                     key={i}
//                     style={{
//                       ...styles.tableRow,
//                       backgroundColor: i % 2 != 0 ? "#f3e7f7" : "",
//                     }}
//                   >
//                     <View
//                       style={{
//                         ...styles.tableCol,
//                         width: "10%",
//                         textAlign: "center",
//                       }}
//                     >
//                       <Text style={styles.tableCell}>
//                         {test.sr_no && test.sr_no}
//                       </Text>
//                     </View>
//                     <View
//                       style={{
//                         ...styles.tableCol,
//                         width: "60%",
//                         color: test.sr_no ? "black" : "#777",
//                       }}
//                     >
//                       <Text style={styles.tableCell}>{test.description}</Text>
//                     </View>
//                     <View
//                       style={{
//                         ...styles.tableCol,
//                         width: "30%",
//                         textAlign: "center",
//                       }}
//                     >
//                       <Text style={styles.tableCell}>
//                         {test.totalcost &&
//                           (proposalData?.currency == "₹"
//                             ? "Rs."
//                             : proposalData?.currency) +
//                             " " +
//                             test.totalcost}
//                       </Text>
//                     </View>
//                   </View>
//                 );
//               })}
//             </View>
//           </View>
//           {/* =============== */}

//           <View style={styles.footer}>
//             <View style={styles.bottomLine}>
//               <View
//                 style={{
//                   height: "100%",
//                   width: "35%",
//                   backgroundColor: "#850505",
//                 }}
//               ></View>

//               <View
//                 style={{
//                   height: "100%",
//                   width: "15%",
//                   backgroundColor: "#fea200",
//                 }}
//               ></View>

//               <View
//                 style={{
//                   height: "100%",
//                   width: "50%",
//                   backgroundColor: "#7cfe00",
//                 }}
//               ></View>
//             </View>
//             <View
//               style={{
//                 display: "flex",
//                 flexDirection: "row",
//                 justifyContent: "space-between",
//               }}
//             >
//               <Text>
//                 © {new Date().getFullYear()}{" "}
//                 {loaction == 1
//                   ? "Zithas Technologies Pvt. Ltd."
//                   : "Zithas Technologies Ltd."}
//               </Text>

//               <Text
//                 render={({ pageNumber, totalPages }) =>
//                   `${pageNumber - 1} of ${totalPages - 1}`
//                 }
//                 fixed
//               ></Text>
//             </View>
//           </View>
//         </Page>
//       )}

//       {costBreakDown.length > 133 && (
//         <Page size="A4" style={styles.body}>
//           <View style={styles.topHeader}>
//             <Text>{proposalData?.proposaltitile}</Text>
//           </View>

//           {/* main Contant */}
//           <View style={{ marginTop: "10px" }}>
//             {/* table */}
//             <View style={{ ...styles.table, width: "100%", marginTop: "20px" }}>
//               <View
//                 style={{
//                   ...styles.tableRow,
//                   backgroundColor: "#d1b9d1",
//                   textTransform: "uppercase",
//                   color: "#6e276c",
//                   fontFamily: "Noto Sans",
//                   fontWeight: 900,
//                 }}
//               >
//                 <View
//                   style={{
//                     ...styles.tableCol,
//                     width: "10%",
//                     textAlign: "center",
//                   }}
//                 >
//                   <Text style={styles.tableCell}>Sr. NO</Text>
//                 </View>
//                 <View style={{ ...styles.tableCol, width: "60%" }}>
//                   <Text style={styles.tableCell}> Description</Text>
//                 </View>
//                 <View
//                   style={{
//                     ...styles.tableCol,
//                     width: "30%",
//                     textAlign: "center",
//                   }}
//                 >
//                   <Text style={styles.tableCell}>TOTAL COST</Text>
//                 </View>
//               </View>
//               {costBreakDown.slice(133, 152).map((test, i) => {
//                 return (
//                   <View
//                     key={i}
//                     style={{
//                       ...styles.tableRow,
//                       backgroundColor: i % 2 != 0 ? "#f3e7f7" : "",
//                     }}
//                   >
//                     <View
//                       style={{
//                         ...styles.tableCol,
//                         width: "10%",
//                         textAlign: "center",
//                       }}
//                     >
//                       <Text style={styles.tableCell}>
//                         {test.sr_no && test.sr_no}
//                       </Text>
//                     </View>
//                     <View
//                       style={{
//                         ...styles.tableCol,
//                         width: "60%",
//                         color: test.sr_no ? "black" : "#777",
//                       }}
//                     >
//                       <Text style={styles.tableCell}>{test.description}</Text>
//                     </View>
//                     <View
//                       style={{
//                         ...styles.tableCol,
//                         width: "30%",
//                         textAlign: "center",
//                       }}
//                     >
//                       <Text style={styles.tableCell}>
//                         {test.totalcost &&
//                           (proposalData?.currency == "₹"
//                             ? "Rs."
//                             : proposalData?.currency) +
//                             " " +
//                             test.totalcost}
//                       </Text>
//                     </View>
//                   </View>
//                 );
//               })}
//             </View>
//           </View>
//           {/* =============== */}

//           <View style={styles.footer}>
//             <View style={styles.bottomLine}>
//               <View
//                 style={{
//                   height: "100%",
//                   width: "35%",
//                   backgroundColor: "#850505",
//                 }}
//               ></View>

//               <View
//                 style={{
//                   height: "100%",
//                   width: "15%",
//                   backgroundColor: "#fea200",
//                 }}
//               ></View>

//               <View
//                 style={{
//                   height: "100%",
//                   width: "50%",
//                   backgroundColor: "#7cfe00",
//                 }}
//               ></View>
//             </View>
//             <View
//               style={{
//                 display: "flex",
//                 flexDirection: "row",
//                 justifyContent: "space-between",
//               }}
//             >
//               <Text>
//                 © {new Date().getFullYear()}{" "}
//                 {loaction == 1
//                   ? "Zithas Technologies Pvt. Ltd."
//                   : "Zithas Technologies Ltd."}
//               </Text>

//               <Text
//                 render={({ pageNumber, totalPages }) =>
//                   `${pageNumber - 1} of ${totalPages - 1}`
//                 }
//                 fixed
//               ></Text>
//             </View>
//           </View>
//         </Page>
//       )}

//       {costBreakDown.length > 152 && (
//         <Page size="A4" style={styles.body}>
//           <View style={styles.topHeader}>
//             <Text>{proposalData?.proposaltitile}</Text>
//           </View>

//           {/* main Contant */}
//           <View style={{ marginTop: "10px" }}>
//             {/* table */}
//             <View style={{ ...styles.table, width: "100%", marginTop: "20px" }}>
//               <View
//                 style={{
//                   ...styles.tableRow,
//                   backgroundColor: "#d1b9d1",
//                   textTransform: "uppercase",
//                   color: "#6e276c",
//                   fontFamily: "Noto Sans",
//                   fontWeight: 900,
//                 }}
//               >
//                 <View
//                   style={{
//                     ...styles.tableCol,
//                     width: "10%",
//                     textAlign: "center",
//                   }}
//                 >
//                   <Text style={styles.tableCell}>Sr. NO</Text>
//                 </View>
//                 <View style={{ ...styles.tableCol, width: "60%" }}>
//                   <Text style={styles.tableCell}> Description</Text>
//                 </View>
//                 <View
//                   style={{
//                     ...styles.tableCol,
//                     width: "30%",
//                     textAlign: "center",
//                   }}
//                 >
//                   <Text style={styles.tableCell}>TOTAL COST</Text>
//                 </View>
//               </View>
//               {costBreakDown.slice(152, 171).map((test, i) => {
//                 return (
//                   <View
//                     key={i}
//                     style={{
//                       ...styles.tableRow,
//                       backgroundColor: i % 2 != 0 ? "#f3e7f7" : "",
//                     }}
//                   >
//                     <View
//                       style={{
//                         ...styles.tableCol,
//                         width: "10%",
//                         textAlign: "center",
//                       }}
//                     >
//                       <Text style={styles.tableCell}>
//                         {test.sr_no && test.sr_no}
//                       </Text>
//                     </View>
//                     <View
//                       style={{
//                         ...styles.tableCol,
//                         width: "60%",
//                         color: test.sr_no ? "black" : "#777",
//                       }}
//                     >
//                       <Text style={styles.tableCell}>{test.description}</Text>
//                     </View>
//                     <View
//                       style={{
//                         ...styles.tableCol,
//                         width: "30%",
//                         textAlign: "center",
//                       }}
//                     >
//                       <Text style={styles.tableCell}>
//                         {test.totalcost &&
//                           (proposalData?.currency == "₹"
//                             ? "Rs."
//                             : proposalData?.currency) +
//                             " " +
//                             test.totalcost}
//                       </Text>
//                     </View>
//                   </View>
//                 );
//               })}
//             </View>
//           </View>
//           {/* =============== */}

//           <View style={styles.footer}>
//             <View style={styles.bottomLine}>
//               <View
//                 style={{
//                   height: "100%",
//                   width: "35%",
//                   backgroundColor: "#850505",
//                 }}
//               ></View>

//               <View
//                 style={{
//                   height: "100%",
//                   width: "15%",
//                   backgroundColor: "#fea200",
//                 }}
//               ></View>

//               <View
//                 style={{
//                   height: "100%",
//                   width: "50%",
//                   backgroundColor: "#7cfe00",
//                 }}
//               ></View>
//             </View>
//             <View
//               style={{
//                 display: "flex",
//                 flexDirection: "row",
//                 justifyContent: "space-between",
//               }}
//             >
//               <Text>
//                 © {new Date().getFullYear()}{" "}
//                 {loaction == 1
//                   ? "Zithas Technologies Pvt. Ltd."
//                   : "Zithas Technologies Ltd."}
//               </Text>

//               <Text
//                 render={({ pageNumber, totalPages }) =>
//                   `${pageNumber - 1} of ${totalPages - 1}`
//                 }
//                 fixed
//               ></Text>
//             </View>
//           </View>
//         </Page>
//       )}

//       {costBreakDown.length > 171 && (
//         <Page size="A4" style={styles.body}>
//           <View style={styles.topHeader}>
//             <Text>{proposalData?.proposaltitile}</Text>
//           </View>

//           {/* main Contant */}
//           <View style={{ marginTop: "10px" }}>
//             {/* table */}
//             <View style={{ ...styles.table, width: "100%", marginTop: "20px" }}>
//               <View
//                 style={{
//                   ...styles.tableRow,
//                   backgroundColor: "#d1b9d1",
//                   textTransform: "uppercase",
//                   color: "#6e276c",
//                   fontFamily: "Noto Sans",
//                   fontWeight: 900,
//                 }}
//               >
//                 <View
//                   style={{
//                     ...styles.tableCol,
//                     width: "10%",
//                     textAlign: "center",
//                   }}
//                 >
//                   <Text style={styles.tableCell}>Sr. NO</Text>
//                 </View>
//                 <View style={{ ...styles.tableCol, width: "60%" }}>
//                   <Text style={styles.tableCell}> Description</Text>
//                 </View>
//                 <View
//                   style={{
//                     ...styles.tableCol,
//                     width: "30%",
//                     textAlign: "center",
//                   }}
//                 >
//                   <Text style={styles.tableCell}>TOTAL COST</Text>
//                 </View>
//               </View>
//               {costBreakDown.slice(171, 190).map((test, i) => {
//                 return (
//                   <View
//                     key={i}
//                     style={{
//                       ...styles.tableRow,
//                       backgroundColor: i % 2 != 0 ? "#f3e7f7" : "",
//                     }}
//                   >
//                     <View
//                       style={{
//                         ...styles.tableCol,
//                         width: "10%",
//                         textAlign: "center",
//                       }}
//                     >
//                       <Text style={styles.tableCell}>
//                         {test.sr_no && test.sr_no}
//                       </Text>
//                     </View>
//                     <View
//                       style={{
//                         ...styles.tableCol,
//                         width: "60%",
//                         color: test.sr_no ? "black" : "#777",
//                       }}
//                     >
//                       <Text style={styles.tableCell}>{test.description}</Text>
//                     </View>
//                     <View
//                       style={{
//                         ...styles.tableCol,
//                         width: "30%",
//                         textAlign: "center",
//                       }}
//                     >
//                       <Text style={styles.tableCell}>
//                         {test.totalcost &&
//                           (proposalData?.currency == "₹"
//                             ? "Rs."
//                             : proposalData?.currency) +
//                             " " +
//                             test.totalcost}
//                       </Text>
//                     </View>
//                   </View>
//                 );
//               })}
//             </View>
//           </View>
//           {/* =============== */}

//           <View style={styles.footer}>
//             <View style={styles.bottomLine}>
//               <View
//                 style={{
//                   height: "100%",
//                   width: "35%",
//                   backgroundColor: "#850505",
//                 }}
//               ></View>

//               <View
//                 style={{
//                   height: "100%",
//                   width: "15%",
//                   backgroundColor: "#fea200",
//                 }}
//               ></View>

//               <View
//                 style={{
//                   height: "100%",
//                   width: "50%",
//                   backgroundColor: "#7cfe00",
//                 }}
//               ></View>
//             </View>
//             <View
//               style={{
//                 display: "flex",
//                 flexDirection: "row",
//                 justifyContent: "space-between",
//               }}
//             >
//               <Text>
//                 © {new Date().getFullYear()}{" "}
//                 {loaction == 1
//                   ? "Zithas Technologies Pvt. Ltd."
//                   : "Zithas Technologies Ltd."}
//               </Text>

//               <Text
//                 render={({ pageNumber, totalPages }) =>
//                   `${pageNumber - 1} of ${totalPages - 1}`
//                 }
//                 fixed
//               ></Text>
//             </View>
//           </View>
//         </Page>
//       )}

//       {costBreakDown.length > 190 && (
//         <Page size="A4" style={styles.body}>
//           <View style={styles.topHeader}>
//             <Text>{proposalData?.proposaltitile}</Text>
//           </View>

//           {/* main Contant */}
//           <View style={{ marginTop: "10px" }}>
//             {/* table */}
//             <View style={{ ...styles.table, width: "100%", marginTop: "20px" }}>
//               <View
//                 style={{
//                   ...styles.tableRow,
//                   backgroundColor: "#d1b9d1",
//                   textTransform: "uppercase",
//                   color: "#6e276c",
//                   fontFamily: "Noto Sans",
//                   fontWeight: 900,
//                 }}
//               >
//                 <View
//                   style={{
//                     ...styles.tableCol,
//                     width: "10%",
//                     textAlign: "center",
//                   }}
//                 >
//                   <Text style={styles.tableCell}>Sr. NO</Text>
//                 </View>
//                 <View style={{ ...styles.tableCol, width: "60%" }}>
//                   <Text style={styles.tableCell}> Description</Text>
//                 </View>
//                 <View
//                   style={{
//                     ...styles.tableCol,
//                     width: "30%",
//                     textAlign: "center",
//                   }}
//                 >
//                   <Text style={styles.tableCell}>TOTAL COST</Text>
//                 </View>
//               </View>
//               {costBreakDown.slice(190, 209).map((test, i) => {
//                 return (
//                   <View
//                     key={i}
//                     style={{
//                       ...styles.tableRow,
//                       backgroundColor: i % 2 != 0 ? "#f3e7f7" : "",
//                     }}
//                   >
//                     <View
//                       style={{
//                         ...styles.tableCol,
//                         width: "10%",
//                         textAlign: "center",
//                       }}
//                     >
//                       <Text style={styles.tableCell}>
//                         {test.sr_no && test.sr_no}
//                       </Text>
//                     </View>
//                     <View
//                       style={{
//                         ...styles.tableCol,
//                         width: "60%",
//                         color: test.sr_no ? "black" : "#777",
//                       }}
//                     >
//                       <Text style={styles.tableCell}>{test.description}</Text>
//                     </View>
//                     <View
//                       style={{
//                         ...styles.tableCol,
//                         width: "30%",
//                         textAlign: "center",
//                       }}
//                     >
//                       <Text style={styles.tableCell}>
//                         {test.totalcost &&
//                           (proposalData?.currency == "₹"
//                             ? "Rs."
//                             : proposalData?.currency) +
//                             " " +
//                             test.totalcost}
//                       </Text>
//                     </View>
//                   </View>
//                 );
//               })}
//             </View>
//           </View>
//           {/* =============== */}

//           <View style={styles.footer}>
//             <View style={styles.bottomLine}>
//               <View
//                 style={{
//                   height: "100%",
//                   width: "35%",
//                   backgroundColor: "#850505",
//                 }}
//               ></View>

//               <View
//                 style={{
//                   height: "100%",
//                   width: "15%",
//                   backgroundColor: "#fea200",
//                 }}
//               ></View>

//               <View
//                 style={{
//                   height: "100%",
//                   width: "50%",
//                   backgroundColor: "#7cfe00",
//                 }}
//               ></View>
//             </View>
//             <View
//               style={{
//                 display: "flex",
//                 flexDirection: "row",
//                 justifyContent: "space-between",
//               }}
//             >
//               <Text>
//                 © {new Date().getFullYear()}{" "}
//                 {loaction == 1
//                   ? "Zithas Technologies Pvt. Ltd."
//                   : "Zithas Technologies Ltd."}
//               </Text>

//               <Text
//                 render={({ pageNumber, totalPages }) =>
//                   `${pageNumber - 1} of ${totalPages - 1}`
//                 }
//                 fixed
//               ></Text>
//             </View>
//           </View>
//         </Page>
//       )}

//       {costBreakDown.length > 209 && (
//         <Page size="A4" style={styles.body}>
//           <View style={styles.topHeader}>
//             <Text>{proposalData?.proposaltitile}</Text>
//           </View>

//           {/* main Contant */}
//           <View style={{ marginTop: "10px" }}>
//             {/* table */}
//             <View style={{ ...styles.table, width: "100%", marginTop: "20px" }}>
//               <View
//                 style={{
//                   ...styles.tableRow,
//                   backgroundColor: "#d1b9d1",
//                   textTransform: "uppercase",
//                   color: "#6e276c",
//                   fontFamily: "Noto Sans",
//                   fontWeight: 900,
//                 }}
//               >
//                 <View
//                   style={{
//                     ...styles.tableCol,
//                     width: "10%",
//                     textAlign: "center",
//                   }}
//                 >
//                   <Text style={styles.tableCell}>Sr. NO</Text>
//                 </View>
//                 <View style={{ ...styles.tableCol, width: "60%" }}>
//                   <Text style={styles.tableCell}> Description</Text>
//                 </View>
//                 <View
//                   style={{
//                     ...styles.tableCol,
//                     width: "30%",
//                     textAlign: "center",
//                   }}
//                 >
//                   <Text style={styles.tableCell}>TOTAL COST</Text>
//                 </View>
//               </View>
//               {costBreakDown.slice(209).map((test, i) => {
//                 return (
//                   <View
//                     key={i}
//                     style={{
//                       ...styles.tableRow,
//                       backgroundColor: i % 2 != 0 ? "#f3e7f7" : "",
//                     }}
//                   >
//                     <View
//                       style={{
//                         ...styles.tableCol,
//                         width: "10%",
//                         textAlign: "center",
//                       }}
//                     >
//                       <Text style={styles.tableCell}>
//                         {test.sr_no && test.sr_no}
//                       </Text>
//                     </View>
//                     <View
//                       style={{
//                         ...styles.tableCol,
//                         width: "60%",
//                         color: test.sr_no ? "black" : "#777",
//                       }}
//                     >
//                       <Text style={styles.tableCell}>{test.description}</Text>
//                     </View>
//                     <View
//                       style={{
//                         ...styles.tableCol,
//                         width: "30%",
//                         textAlign: "center",
//                       }}
//                     >
//                       <Text style={styles.tableCell}>
//                         {test.totalcost &&
//                           (proposalData?.currency == "₹"
//                             ? "Rs."
//                             : proposalData?.currency) +
//                             " " +
//                             test.totalcost}
//                       </Text>
//                     </View>
//                   </View>
//                 );
//               })}
//             </View>
//           </View>
//           {/* =============== */}

//           <View style={styles.footer}>
//             <View style={styles.bottomLine}>
//               <View
//                 style={{
//                   height: "100%",
//                   width: "35%",
//                   backgroundColor: "#850505",
//                 }}
//               ></View>

//               <View
//                 style={{
//                   height: "100%",
//                   width: "15%",
//                   backgroundColor: "#fea200",
//                 }}
//               ></View>

//               <View
//                 style={{
//                   height: "100%",
//                   width: "50%",
//                   backgroundColor: "#7cfe00",
//                 }}
//               ></View>
//             </View>
//             <View
//               style={{
//                 display: "flex",
//                 flexDirection: "row",
//                 justifyContent: "space-between",
//               }}
//             >
//               <Text>
//                 © {new Date().getFullYear()}{" "}
//                 {loaction == 1
//                   ? "Zithas Technologies Pvt. Ltd."
//                   : "Zithas Technologies Ltd."}
//               </Text>

//               <Text
//                 render={({ pageNumber, totalPages }) =>
//                   `${pageNumber - 1} of ${totalPages - 1}`
//                 }
//                 fixed
//               ></Text>
//             </View>
//           </View>
//         </Page>
//       )}

//       {/* cost breakdown ========================================= */}

//       <Page size="A4" style={styles.body}>
//         <View style={styles.topHeader}>
//           <Text>{proposalData?.proposaltitile}</Text>
//         </View>

//         {/* main Contant */}
//         <View style={{ marginTop: "22px" }}>
//           <Text
//             style={{
//               color: "#7E5F00",
//               fontSize: "12px",
//               fontWeight: 800,
//               letterSpacing: "0.5px",
//               textTransform: "uppercase",
//               marginBottom: "10px",
//             }}
//           >
//             7. CONCLUSION
//           </Text>

//           <Text style={styles.paragraph}>
//             Again, we are happy to present this proposal for your review. Upon
//             acceptance of this proposal, the Provider will draft a comprehensive
//             statement of work for your review that will serve as the project
//             contract between the Provider and the Client
//           </Text>
//           <Text style={styles.paragraph}>
//             If you have any questions or need additional information amended to
//             the proposal, please let us know. You can reach us directly by phone
//             at{" "}
//             <Text style={{ color: "purple" }}>
//               {proposalData?.conclusion_contact}
//             </Text>{" "}
//             or by email at{" "}
//             <Text style={{ color: "purple" }}>
//               {proposalData?.conclusion_email}
//             </Text>
//           </Text>
//         </View>
//         {/* =============== */}

//         <View style={styles.footer}>
//           <View style={styles.bottomLine}>
//             <View
//               style={{
//                 height: "100%",
//                 width: "35%",
//                 backgroundColor: "#850505",
//               }}
//             ></View>

//             <View
//               style={{
//                 height: "100%",
//                 width: "15%",
//                 backgroundColor: "#fea200",
//               }}
//             ></View>

//             <View
//               style={{
//                 height: "100%",
//                 width: "50%",
//                 backgroundColor: "#7cfe00",
//               }}
//             ></View>
//           </View>
//           <View
//             style={{
//               display: "flex",
//               flexDirection: "row",
//               justifyContent: "space-between",
//             }}
//           >
//             <Text>
//               © {new Date().getFullYear()}{" "}
//               {loaction == 1
//                 ? "Zithas Technologies Pvt. Ltd."
//                 : "Zithas Technologies Ltd."}
//             </Text>

//             <Text
//               render={({ pageNumber, totalPages }) =>
//                 `${pageNumber - 1} of ${totalPages - 1}`
//               }
//               fixed
//             ></Text>
//           </View>
//         </View>
//       </Page>
//     </Document>
//   );
// };

// const ProposalPdf = ({ proposal_id }) => {
//   const [viewData, setViewData] = useState(false);
//   const [proposalData, setProposalData] = useState([]);
//   const [loaction, setLocation] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [allEmails, setAllEmails] = useState([]);

//   const FetchProposalData = async () => {
//     setLoading(true);
//     const formData = new FormData();
//     formData.append("proposal_id", proposal_id);

//     try {
//       const response = await axios({
//         method: "post",
//         url: `${configure.nodeApi}/view_proposal`,
//         data: formData,
//         headers: {
//           Accept: "application/json",
//           "Content-Type": "multipart/form-data",
//         },
//       });

//       const d = response.data.data[0];
//       setProposalData(d);
//       setLocation(d.location);

//       const emails = new Set();

//       // Always add proposal client email + provider email
//       if (d.email) emails.add(d.email);
//       if (d.provideremail) emails.add(d.provideremail);

//       if (d.related === "lead" && d.source_name) {
//         try {
//           const leadRes = await axios.get(
//             `${configure.nodeApi}/lead_emails?lead_id=${d.source_name}`,
//             { headers: { Accept: "application/json" } },
//           );
//           if (leadRes.data.success && Array.isArray(leadRes.data.data)) {
//             leadRes.data.data.forEach((email) => {
//               if (email) emails.add(email);
//             });
//           }
//         } catch (err) {
//           console.error("Failed to fetch lead emails:", err);
//         }
//       }

//       setAllEmails([...emails]);
//       setViewData(true);
//       console.log("allEmails :", allEmails);
//     } catch (err) {
//       console.error("FetchProposalData error:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <>
//       {loading && <Loader />}

//       <button
//         className="btn btn-sm btn-outline-secondary me-1"
//         onClick={() => {
//           // fetching proposal data
//           FetchProposalData();
//         }}
//       >
//         <i className="fa fa-file-pdf"></i>
//       </button>

//       <Modal size="xl" centered isOpen={viewData} className="modal-fullscreen">
//         <div className="modal-header">
//           <h5 className="modal-title mt-0">Download Proposal</h5>
//           <div className="d-flex align-items-center ms-auto">
//             <div>

//               <button
//   className="btn btn-sm btn-outline-primary me-2"
//   title="Send Email"
//   onClick={() => {
//     const to = encodeURIComponent(allEmails.join(";"));
//     const subject = encodeURIComponent(proposalData?.proposaltitile || "Proposal");
//     window.open(
//       `https://outlook.cloud.microsoft/mail/deeplink/compose?to=${to}&subject=${subject}`,
//       "_blank"
//     );
//   }}
// >
//   <i className="fa fa-envelope"></i> Send Email
//   {allEmails.length > 0 && (
//     <span className="badge bg-secondary ms-1">{allEmails.length}</span>
//   )}
// </button>
//             </div>
//             <button
//               type="button"
//               onClick={() => {
//                 setViewData(false);
//               }}
//               className="btn-modal-close"
//               style={{ marginTop: "8px" }}
//             >
//               <span aria-hidden="true" className="btn-modal-span">
//                 &times;
//               </span>
//             </button>
//           </div>
//         </div>
//         <div className="modal-body">
//           <PDFViewer width="100%" height="800px">
//             <MyProposalDocument
//               loaction={loaction}
//               proposalData={proposalData}
//             />
//           </PDFViewer>
//         </div>
//       </Modal>
//     </>
//   );
// };

// export default ProposalPdf;

// import React, { useState } from "react";
// import { Modal } from "reactstrap";
// import {
//   Document,
//   Page,
//   Image,
//   Text,
//   StyleSheet,
//   PDFViewer,
//   View,
//   Font,
//   Line,
//   Svg,
// } from "@react-pdf/renderer";
// import zithasLogo from "../../../assets/images/zithas-dark-logo.png";
// import JuliusSir from "../../../assets/images/julius.png";
// import axios from "axios";
// import configure from "configure";
// import moment from "moment";
// import Loader from "pages/Separate/Loader";

// // ─── Font Registration ────────────────────────────────────────────────────────
// // Font.register({
// //   family: "Noto Sans",
// //   fonts: [{ src: "https://fonts.boords.com/NotoSans-Regular.ttf" }],
// // });

// // ─── Styles ───────────────────────────────────────────────────────────────────
// const C = {
//   primary: "#1a1a2e",
//   accent: "#c8a951",
//   accentLight: "#f5e6b8",
//   purple: "#5b2d8e",
//   purpleLight: "#ede4f5",
//   text: "#2d2d2d",
//   muted: "#666",
//   border: "#ddd",
//   white: "#ffffff",
//   bgLight: "#fafafa",
//   tableHeader: "#1a1a2e",
//   tableAlt: "#f5f0fb",
//   red: "#8b0000",
//   orange: "#fea200",
//   green: "#5a9e00",
// };

// const styles = StyleSheet.create({
//   page: {
//     paddingTop: 40,
//     paddingBottom: 60,
//     paddingHorizontal: 35,
//     //fontFamily: "Noto Sans",
//     backgroundColor: C.white,
//     color: C.text,
//     fontSize: 10,
//   },

//   // ── Header bar ──
//   headerBar: {
//     backgroundColor: C.primary,
//     paddingHorizontal: 35,
//     paddingVertical: 10,
//     marginTop: -40,
//     marginHorizontal: -35,
//     marginBottom: 24,
//     flexDirection: "row",
//     justifyContent: "space-between",
//     alignItems: "center",
//   },
//   headerBarText: {
//     color: C.white,
//     fontSize: 8,
//     letterSpacing: 0.5,
//   },
//   headerBarAccent: {
//     color: C.accent,
//     fontSize: 8,
//   },

//   // ── Logo page ──
//   logoContainer: {
//     alignItems: "center",
//     marginTop: 30,
//     marginBottom: 12,
//   },
//   logo: { width: 160, height: 50, objectFit: "contain" },
//   tagline: {
//     fontSize: 9,
//     color: C.accent,
//     letterSpacing: 2,
//     textAlign: "center",
//     marginTop: 4,
//     textTransform: "uppercase",
//   },

//   // ── Cover divider ──
//   accentLine: {
//     height: 3,
//     backgroundColor: C.accent,
//     marginVertical: 20,
//     marginHorizontal: 0,
//   },
//   thinLine: {
//     height: 1,
//     backgroundColor: C.border,
//     marginVertical: 12,
//   },

//   // ── Cover title ──
//   coverTitle: {
//     fontSize: 22,
//     color: C.primary,
//     textAlign: "center",
//     fontWeight: "bold",
//     marginBottom: 6,
//     letterSpacing: 0.5,
//   },
//   coverSubtitle: {
//     fontSize: 12,
//     color: C.muted,
//     textAlign: "center",
//     marginBottom: 24,
//   },

//   // ── Info tables on cover ──
//   infoTablesRow: {
//     flexDirection: "row",
//     gap: 16,
//     marginTop: 20,
//   },
//   infoTable: {
//     flex: 1,
//     borderWidth: 1,
//     borderColor: C.border,
//     borderRadius: 4,
//     overflow: "hidden",
//   },
//   infoTableHeader: {
//     backgroundColor: C.primary,
//     paddingVertical: 7,
//     paddingHorizontal: 10,
//   },
//   infoTableHeaderText: {
//     color: C.white,
//     fontSize: 9,
//     fontWeight: "bold",
//     letterSpacing: 0.8,
//     textTransform: "uppercase",
//     textAlign: "center",
//   },
//   infoRow: {
//     flexDirection: "row",
//     borderBottomWidth: 1,
//     borderBottomColor: C.border,
//   },
//   infoLabel: {
//     width: "35%",
//     paddingVertical: 5,
//     paddingHorizontal: 8,
//     fontSize: 8.5,
//     color: C.muted,
//     fontWeight: "bold",
//     backgroundColor: "#f8f8f8",
//   },
//   infoValue: {
//     width: "65%",
//     paddingVertical: 5,
//     paddingHorizontal: 8,
//     fontSize: 8.5,
//     color: C.text,
//   },

//   // ── Cover footer note ──
//   coverNote: {
//     marginTop: 24,
//     padding: 12,
//     backgroundColor: C.purpleLight,
//     borderLeftWidth: 3,
//     borderLeftColor: C.purple,
//     fontSize: 9,
//     color: C.text,
//     lineHeight: 1.6,
//   },

//   // ── Page header (inner pages) ──
//   pageHeader: {
//     flexDirection: "row",
//     justifyContent: "space-between",
//     alignItems: "center",
//     borderBottomWidth: 2,
//     borderBottomColor: C.primary,
//     paddingBottom: 8,
//     marginBottom: 20,
//   },
//   pageHeaderTitle: {
//     fontSize: 13,
//     color: C.primary,
//     fontWeight: "bold",
//   },
//   pageHeaderLogo: { width: 80, height: 25, objectFit: "contain" },

//   // ── Section heading ──
//   sectionHeading: {
//     fontSize: 11,
//     color: C.primary,
//     fontWeight: "bold",
//     letterSpacing: 0.8,
//     textTransform: "uppercase",
//     marginBottom: 10,
//     borderBottomWidth: 1,
//     borderBottomColor: C.accentLight,
//     paddingBottom: 4,
//   },
//   sectionNumber: {
//     color: C.accent,
//     fontSize: 13,
//   },

//   // ── Paragraph ──
//   para: {
//     fontSize: 9.5,
//     color: C.text,
//     lineHeight: 1.7,
//     marginBottom: 8,
//   },

//   // ── Feature table ──
//   featureTable: {
//     marginTop: 10,
//     borderWidth: 1,
//     borderColor: C.border,
//     borderRadius: 4,
//     overflow: "hidden",
//   },
//   featureTableHeader: {
//     flexDirection: "row",
//     backgroundColor: C.tableHeader,
//     paddingVertical: 7,
//     paddingHorizontal: 8,
//   },
//   featureTableHeaderCell: {
//     color: C.white,
//     fontSize: 8.5,
//     fontWeight: "bold",
//     letterSpacing: 0.5,
//   },
//   featureRow: {
//     flexDirection: "row",
//     borderBottomWidth: 1,
//     borderBottomColor: C.border,
//     paddingVertical: 6,
//     paddingHorizontal: 8,
//   },
//   featureRowAlt: {
//     backgroundColor: C.tableAlt,
//   },
//   featureCell: {
//     fontSize: 8.5,
//     color: C.text,
//   },

//   // ── Phase timeline ──
//   phaseRow: {
//     flexDirection: "row",
//     marginBottom: 8,
//     alignItems: "flex-start",
//   },
//   phaseBadge: {
//     backgroundColor: C.primary,
//     paddingHorizontal: 8,
//     paddingVertical: 3,
//     borderRadius: 2,
//     marginRight: 10,
//     minWidth: 22,
//     alignItems: "center",
//   },
//   phaseBadgeText: { color: C.white, fontSize: 8, fontWeight: "bold" },
//   phaseContent: { flex: 1 },
//   phaseTitle: { fontSize: 9.5, fontWeight: "bold", color: C.primary, marginBottom: 2 },
//   phaseBody: { fontSize: 9, color: C.muted, lineHeight: 1.5 },

//   // ── Cost table ──
//   costTable: {
//     marginTop: 10,
//     borderWidth: 1,
//     borderColor: C.border,
//     borderRadius: 4,
//     overflow: "hidden",
//   },
//   costHeader: {
//     flexDirection: "row",
//     backgroundColor: C.primary,
//     paddingVertical: 7,
//     paddingHorizontal: 8,
//   },
//   costHeaderText: { color: C.white, fontSize: 8.5, fontWeight: "bold" },
//   costRow: {
//     flexDirection: "row",
//     borderBottomWidth: 1,
//     borderBottomColor: C.border,
//     paddingVertical: 7,
//     paddingHorizontal: 8,
//   },
//   costRowHighlight: {
//     backgroundColor: C.accentLight,
//   },
//   costCell: { fontSize: 9, color: C.text },
//   costCellBold: { fontSize: 9, color: C.primary, fontWeight: "bold" },

//   // ── Payment milestone ──
//   milestoneRow: {
//     flexDirection: "row",
//     alignItems: "center",
//     marginBottom: 6,
//   },
//   milestoneDot: {
//     width: 8,
//     height: 8,
//     borderRadius: 4,
//     backgroundColor: C.accent,
//     marginRight: 8,
//   },
//   milestoneText: { fontSize: 9, color: C.text },

//   // ── Strengths table ──
//   strengthRow: {
//     flexDirection: "row",
//     borderBottomWidth: 1,
//     borderBottomColor: C.border,
//     paddingVertical: 7,
//     paddingHorizontal: 8,
//   },
//   strengthNum: {
//     width: "6%",
//     fontSize: 8.5,
//     color: C.accent,
//     fontWeight: "bold",
//   },
//   strengthTitle: {
//     width: "30%",
//     fontSize: 8.5,
//     color: C.primary,
//     fontWeight: "bold",
//   },
//   strengthDesc: { flex: 1, fontSize: 8.5, color: C.muted, lineHeight: 1.5 },

//   // ── About stats ──
//   statsRow: {
//     flexDirection: "row",
//     justifyContent: "space-around",
//     marginVertical: 16,
//   },
//   statBox: {
//     alignItems: "center",
//     backgroundColor: C.purpleLight,
//     borderRadius: 6,
//     padding: 12,
//     width: "28%",
//   },
//   statNumber: { fontSize: 20, color: C.primary, fontWeight: "bold" },
//   statLabel: { fontSize: 8, color: C.muted, marginTop: 2, textAlign: "center" },

//   // ── Thank you page ──
//   thankYouBox: {
//     backgroundColor: C.primary,
//     borderRadius: 8,
//     padding: 28,
//     marginTop: 20,
//     alignItems: "center",
//   },
//   thankYouTitle: {
//     color: C.accent,
//     fontSize: 22,
//     fontWeight: "bold",
//     textAlign: "center",
//     marginBottom: 6,
//   },
//   thankYouSub: {
//     color: C.white,
//     fontSize: 10,
//     textAlign: "center",
//     lineHeight: 1.7,
//     marginBottom: 20,
//   },
//   contactCard: {
//     backgroundColor: "rgba(255,255,255,0.1)",
//     borderRadius: 6,
//     padding: 14,
//     marginTop: 8,
//     width: "100%",
//   },
//   contactLabel: { color: C.accent, fontSize: 8, letterSpacing: 1, textTransform: "uppercase", marginBottom: 4 },
//   contactValue: { color: C.white, fontSize: 9, lineHeight: 1.6 },

//   // ── Footer ──
//   footer: {
//     position: "absolute",
//     bottom: 20,
//     left: 35,
//     right: 35,
//   },
//   footerBar: {
//     flexDirection: "row",
//     height: 3,
//     marginBottom: 6,
//   },
//   footerText: {
//     flexDirection: "row",
//     justifyContent: "space-between",
//   },
//   footerLabel: { fontSize: 7.5, color: C.muted },

//   // ── Confidential stamp ──
//   confidential: {
//     fontSize: 7,
//     color: C.muted,
//     textAlign: "center",
//     marginTop: 4,
//   },

//   // ── Highlight box ──
//   highlightBox: {
//     backgroundColor: C.purpleLight,
//     borderLeftWidth: 3,
//     borderLeftColor: C.purple,
//     padding: 10,
//     marginTop: 10,
//     marginBottom: 6,
//     borderRadius: 2,
//   },
//   highlightText: { fontSize: 9, color: C.text, lineHeight: 1.6 },
// });

// // ─── Footer Component ─────────────────────────────────────────────────────────
// const Footer = ({ location, proposalData }) => (
//   <View style={styles.footer} fixed>
//     <View style={styles.footerBar}>
//       <View style={{ flex: 3.5, backgroundColor: C.red }} />
//       <View style={{ flex: 1.5, backgroundColor: C.orange }} />
//       <View style={{ flex: 5, backgroundColor: C.green }} />
//     </View>
//     <View style={styles.footerText}>
//       <Text style={styles.footerLabel}>
//         {location == 1
//           ? "Zithas Technologies Pvt. Ltd."
//           : "Zithas Technologies Ltd."}{" "}
//         | {proposalData?.proposaltitile || "Proposal"} — Confidential
//       </Text>
//       <Text
//         style={styles.footerLabel}
//         render={({ pageNumber, totalPages }) =>
//           `Page ${pageNumber} of ${totalPages}`
//         }
//       />
//     </View>
//   </View>
// );

// // ─── Page Header (inner pages) ────────────────────────────────────────────────
// const PageHeader = ({ proposalData }) => (
//   <View style={styles.pageHeader}>
//     <Text style={styles.pageHeaderTitle}>
//       {proposalData?.proposaltitile || "Proposal"}
//     </Text>
//     <Image style={styles.pageHeaderLogo} src={zithasLogo} />
//   </View>
// );

// // ─── Main Document ────────────────────────────────────────────────────────────
// const MyProposalDocument = ({ loaction, proposalData }) => {
//   const clientEmail = proposalData?.email || "";
//   const clientPhone = proposalData?.cilentcontact || "";
//   const clientAddress = proposalData?.address || "";

//   const clientInfo = [
//     { label: "Company", value: proposalData?.companyname },
//     { label: "Contact", value: proposalData?.contactname },
//     { label: "Address", value: clientAddress },
//     { label: "Phone", value: clientPhone },
//     { label: "Email", value: clientEmail },
//     { label: "Website", value: proposalData?.website },
//   ];

//   const providerInfo = [
//     { label: "Company", value: proposalData?.company2 || (loaction == 1 ? "Zithas Technologies Pvt. Ltd." : "Zithas Technologies Ltd.") },
//     { label: "Contact", value: proposalData?.contactmember },
//     { label: "Address", value: proposalData?.address1 },
//     { label: "Phone", value: proposalData?.contact },
//     { label: "Email", value: proposalData?.provideremail },
//     { label: "Website", value: proposalData?.website1 },
//   ];

//   const features = [
//     { num: "1", title: "Website Transformation", desc: "Modern, clean, professional visual interface with dynamic hero banners, strategic CTAs, and structured content layout for enhanced readability." },
//     { num: "2", title: "Full Responsive Framework", desc: "Optimized across desktop, tablet & mobile. Cross-browser compatibility (Chrome, Firefox, Safari, Edge). Mobile-first design with touch-friendly navigation." },
//     { num: "3", title: "Engagement & Animations", desc: "Subtitle section transition effects, hover interactions, animated icons and graphics, and interactive backgrounds where applicable." },
//     { num: "4", title: "User Account & Auth", desc: "User registration, login, logout, password reset via email, profile management (address book, order history), wishlist & saved items." },
//     { num: "5", title: "Product Pages", desc: "Clean listing page with filters & search, multiple product images & zoom, product variants, stock availability, related products, CTA buttons." },
//     { num: "6", title: "Shopping Cart & Checkout", desc: "Add/remove/update cart items, save cart for later, guest checkout option, order summary." },
//     { num: "7", title: "Order Management", desc: "Order confirmation email, real-time order tracking, order history & invoice download, return/refund request, cancellation before dispatch." },
//     { num: "8", title: "Payment Integration", desc: "Integration with secure payment gateways and cash on delivery. Real-time payment status updates. Secure checkout with easy refund management." },
//     { num: "9", title: "Contact & Blog", desc: "Contact form with Google Maps embed, business hours display. Blog listing, detail pages, categories & tags, related posts." },
//     { num: "10", title: "SEO & Accessibility", desc: "SEO-friendly URL structure, meta title & description, image optimization, page speed optimization. WCAG 2.1 AA compliance built in." },
//     { num: "11", title: "Admin Dashboard", desc: "Sales overview, revenue charts, top-selling products, recent orders & alerts, low stock notifications, product & order management." },
//     { num: "12", title: "Reports & Analytics", desc: "Sales reports by product/category/region, inventory reports, payment & transaction reports, export to PDF." },
//   ];

//   const phases = [
//     { num: "1", title: "Discovery & Strategy", duration: "Week 1", desc: "Requirement specification, user personas, content plan, project scope definition." },
//     { num: "2", title: "UI/UX Design", duration: "Week 2–3", desc: "Design system, wireframes, component library, client approval gates." },
//     { num: "3", title: "Development", duration: "Week 3–7", desc: "Admin panel, all core pages, feature implementation, API integrations." },
//     { num: "4", title: "Content Integration", duration: "Week 7–8", desc: "Upload, format, and SEO-optimize all client-provided content." },
//     { num: "5", title: "QA & Testing", duration: "Week 8", desc: "Functional, accessibility, performance, and security testing." },
//     { num: "6", title: "Deployment", duration: "Week 8", desc: "Go-live preparation, SSL configuration, production deployment." },
//   ];

//   const milestones = [
//     { label: "Advance — 50%", trigger: "Agreement executed" },
//     { label: "Mid-project — 30%", trigger: "50% development completed" },
//     { label: "Final — 20%", trigger: "Production deployment" },
//   ];

//   const strengths = [
//     { num: "1", title: "12+ Years of Expertise", desc: "Deep technical capability built over a decade — not a start-up experimenting on your project." },
//     { num: "2", title: "End-to-End Delivery", desc: "Strategy to Launch to Support — one team, one contact, zero handoff gaps." },
//     { num: "3", title: "Accessibility by Default", desc: "Every site meets WCAG 2.1 AA — built in, not bolted on." },
//     { num: "4", title: "Performance-Obsessed", desc: "Our builds consistently achieve 90+ on Google Lighthouse." },
//     { num: "5", title: "Transparent Pricing", desc: "No hidden costs — milestone-based payments, full disclosure before work begins." },
//     { num: "6", title: "Post-Launch Partnership", desc: "AMC/retainer plans ensure your site stays current and supported long after go-live." },
//   ];

//   const companyName = proposalData?.companyname || "the Client";
//   const title = proposalData?.proposaltitile || "Website Development Proposal";
//   const date = proposalData?.date ? moment(proposalData.date).format("DD MMMM YYYY") : moment().format("DD MMMM YYYY");
//   const currency = proposalData?.currency === "₹" ? "INR" : (proposalData?.currency || "");

//   return (
//     <Document>
//       {/* ════════════════════════════════════════════════════════════════════
//           PAGE 1 — COVER
//       ════════════════════════════════════════════════════════════════════ */}
//       <Page size="A4" style={styles.page}>
//         {/* Top bar */}
//         <View style={styles.headerBar}>
//           <Text style={styles.headerBarText}>
//             {loaction == 1 ? "Zithas Technologies Pvt. Ltd." : "Zithas Technologies Ltd."}{" "}
//             | Website Development Proposal  |  Confidential
//           </Text>
//           <Text style={styles.headerBarAccent}>
//             {proposalData?.provideremail || ""}  |  {proposalData?.website1 || ""}
//           </Text>
//         </View>

//         {/* Logo */}
//         <View style={styles.logoContainer}>
//           <Image style={styles.logo} src={zithasLogo} />
//           <Text style={styles.tagline}>You Grow | We Grow</Text>
//         </View>

//         <View style={styles.accentLine} />

//         {/* Title */}
//         <Text style={styles.coverTitle}>{title}</Text>
//         <Text style={styles.coverSubtitle}>Prepared for {companyName}</Text>
//         <Text style={{ fontSize: 9, color: C.muted, textAlign: "center", marginBottom: 4 }}>{date}</Text>

//         {/* Info Tables */}
//         <View style={styles.infoTablesRow}>
//           {/* Client */}
//           <View style={styles.infoTable}>
//             <View style={styles.infoTableHeader}>
//               <Text style={styles.infoTableHeaderText}>Client Information</Text>
//             </View>
//             {clientInfo.map((row, i) => (
//               <View key={i} style={styles.infoRow}>
//                 <Text style={styles.infoLabel}>{row.label}</Text>
//                 <Text style={styles.infoValue}>{row.value && row.value !== "null" ? row.value : "—"}</Text>
//               </View>
//             ))}
//           </View>
//           {/* Provider */}
//           <View style={styles.infoTable}>
//             <View style={styles.infoTableHeader}>
//               <Text style={styles.infoTableHeaderText}>Provider Information</Text>
//             </View>
//             {providerInfo.map((row, i) => (
//               <View key={i} style={styles.infoRow}>
//                 <Text style={styles.infoLabel}>{row.label}</Text>
//                 <Text style={styles.infoValue}>{row.value && row.value !== "null" ? row.value : "—"}</Text>
//               </View>
//             ))}
//           </View>
//         </View>

//         {/* Cover note */}
//         <View style={styles.coverNote}>
//           <Text>
//             Zithas Technologies is pleased to present this proposal to {companyName} for the design,
//             development, and deployment of a professional digital platform aligned with your mission and digital goals.
//           </Text>
//         </View>

//         <Footer location={loaction} proposalData={proposalData} />
//       </Page>

//       {/* ════════════════════════════════════════════════════════════════════
//           PAGE 2 — PROJECT INFORMATION & FEATURES
//       ════════════════════════════════════════════════════════════════════ */}
//       <Page size="A4" style={styles.page}>
//         <PageHeader proposalData={proposalData} />

//         {/* Project Information block */}
//         <Text style={styles.sectionHeading}>Project Information</Text>

//         <View style={{ flexDirection: "row", flexWrap: "wrap", gap: 8, marginBottom: 14 }}>
//           {[
//             { label: "Project Title", value: title },
//             { label: "Proposed Go-Live", value: "~8 weeks from contract signing" },
//             { label: "Engagement Model", value: "Fixed-scope project with optional AMC retainer" },
//             { label: "Primary Contact", value: `${proposalData?.contactmember || ""}  ${proposalData?.provideremail || ""}` },
//           ].map((item, i) => (
//             <View key={i} style={{ flexDirection: "row", width: "100%", marginBottom: 4, borderBottomWidth: 1, borderBottomColor: C.border, paddingBottom: 4 }}>
//               <Text style={{ width: "28%", fontSize: 9, color: C.muted, fontWeight: "bold" }}>{item.label}</Text>
//               <Text style={{ flex: 1, fontSize: 9, color: C.text }}>{item.value}</Text>
//             </View>
//           ))}
//         </View>

//         {/* Project Objective */}
//         <Text style={{ ...styles.sectionHeading, marginTop: 6 }}>Project Objective</Text>
//         <Text style={styles.para}>
//           {companyName} requires a scalable, secure digital platform that establishes a strong, trustworthy online
//           presence enhancing brand credibility and customer confidence. The platform will showcase products with clear
//           descriptions, high-quality visuals, pricing, and availability while delivering a seamless experience with
//           intuitive navigation and mobile-friendly UX, enabling secure and efficient checkout with multiple payment
//           gateway integrations.
//         </Text>

//         {/* Feature List */}
//         <Text style={{ ...styles.sectionHeading, marginTop: 8 }}>Feature List — Core Modules</Text>
//         <View style={styles.featureTable}>
//           <View style={styles.featureTableHeader}>
//             <Text style={{ ...styles.featureTableHeaderCell, width: "6%" }}>#</Text>
//             <Text style={{ ...styles.featureTableHeaderCell, width: "30%" }}>Module</Text>
//             <Text style={{ ...styles.featureTableHeaderCell, flex: 1 }}>Key Features</Text>
//           </View>
//           {features.map((f, i) => (
//             <View key={i} style={[styles.featureRow, i % 2 !== 0 && styles.featureRowAlt]}>
//               <Text style={{ ...styles.featureCell, width: "6%", color: C.accent, fontWeight: "bold" }}>{f.num}</Text>
//               <Text style={{ ...styles.featureCell, width: "30%", color: C.primary, fontWeight: "bold" }}>{f.title}</Text>
//               <Text style={{ ...styles.featureCell, flex: 1, color: C.muted, lineHeight: 1.5 }}>{f.desc}</Text>
//             </View>
//           ))}
//         </View>

//         <Footer location={loaction} proposalData={proposalData} />
//       </Page>

//       {/* ════════════════════════════════════════════════════════════════════
//           PAGE 3 — TIMELINE & COST
//       ════════════════════════════════════════════════════════════════════ */}
//       <Page size="A4" style={styles.page}>
//         <PageHeader proposalData={proposalData} />

//         <Text style={styles.sectionHeading}>Timeline & Cost</Text>

//         {/* Phase table */}
//         <Text style={{ fontSize: 9.5, color: C.primary, fontWeight: "bold", marginBottom: 8 }}>
//           Project Timeline (~8 Weeks)
//         </Text>
//         <View style={styles.featureTable}>
//           <View style={styles.featureTableHeader}>
//             <Text style={{ ...styles.featureTableHeaderCell, width: "6%" }}>Ph.</Text>
//             <Text style={{ ...styles.featureTableHeaderCell, width: "30%" }}>Phase</Text>
//             <Text style={{ ...styles.featureTableHeaderCell, width: "18%" }}>Duration</Text>
//             <Text style={{ ...styles.featureTableHeaderCell, flex: 1 }}>Key Deliverables</Text>
//           </View>
//           {phases.map((p, i) => (
//             <View key={i} style={[styles.featureRow, i % 2 !== 0 && styles.featureRowAlt]}>
//               <Text style={{ ...styles.featureCell, width: "6%", color: C.accent, fontWeight: "bold" }}>{p.num}</Text>
//               <Text style={{ ...styles.featureCell, width: "30%", color: C.primary, fontWeight: "bold" }}>{p.title}</Text>
//               <Text style={{ ...styles.featureCell, width: "18%", color: C.muted }}>{p.duration}</Text>
//               <Text style={{ ...styles.featureCell, flex: 1, color: C.muted, lineHeight: 1.5 }}>{p.desc}</Text>
//             </View>
//           ))}
//         </View>

//         {/* Investment */}
//         <Text style={{ fontSize: 9.5, color: C.primary, fontWeight: "bold", marginTop: 18, marginBottom: 8 }}>
//           Project Investment
//         </Text>
//         <View style={styles.costTable}>
//           <View style={styles.costHeader}>
//             <Text style={{ ...styles.costHeaderText, flex: 1 }}>Description</Text>
//             <Text style={{ ...styles.costHeaderText, width: "35%" }}>Price</Text>
//           </View>
//           <View style={styles.costRow}>
//             <Text style={{ ...styles.costCell, flex: 1 }}>{title}</Text>
//             <Text style={{ ...styles.costCell, width: "35%", color: C.muted }}>As per agreement</Text>
//           </View>
//           <View style={[styles.costRow, styles.costRowHighlight]}>
//             <Text style={{ ...styles.costCellBold, flex: 1 }}>Total Project Cost</Text>
//             <Text style={{ ...styles.costCellBold, width: "35%" }}>As per agreement</Text>
//           </View>
//         </View>

//         {/* Payment milestones */}
//         <Text style={{ fontSize: 9.5, color: C.primary, fontWeight: "bold", marginTop: 18, marginBottom: 8 }}>
//           Payment Milestones
//         </Text>
//         <View style={styles.featureTable}>
//           <View style={styles.featureTableHeader}>
//             <Text style={{ ...styles.featureTableHeaderCell, width: "40%" }}>Milestone</Text>
//             <Text style={{ ...styles.featureTableHeaderCell, width: "20%" }}>Payment %</Text>
//             <Text style={{ ...styles.featureTableHeaderCell, flex: 1 }}>Trigger</Text>
//           </View>
//           {milestones.map((m, i) => (
//             <View key={i} style={[styles.featureRow, i % 2 !== 0 && styles.featureRowAlt]}>
//               <Text style={{ ...styles.featureCell, width: "40%", color: C.primary, fontWeight: "bold" }}>{m.label}</Text>
//               <Text style={{ ...styles.featureCell, width: "20%", color: C.accent }}>
//                 {m.label.includes("50") ? "50%" : m.label.includes("30") ? "30%" : "20%"}
//               </Text>
//               <Text style={{ ...styles.featureCell, flex: 1, color: C.muted }}>{m.trigger}</Text>
//             </View>
//           ))}
//         </View>

//         <View style={styles.highlightBox}>
//           <Text style={styles.highlightText}>
//             Domain, hosting, and SSL are billed directly to {companyName}. All recurring / third-party costs are
//             disclosed before engagement begins.
//           </Text>
//         </View>

//         {/* Our Approach */}
//         <Text style={{ fontSize: 9.5, color: C.primary, fontWeight: "bold", marginTop: 18, marginBottom: 8 }}>
//           Our Development Approach
//         </Text>
//         <View style={{ flexDirection: "row", gap: 8 }}>
//           {["STRATEGY\nRequirement analysis, scope definition, project concept & information architecture",
//             "PLANNING\nDesign system, functional specs, client approval",
//             "BUILD\nFront-end & back-end development, content integration, QA & testing",
//             "DEPLOY\nProduction deployment, SSL config, go-live support"].map((item, i) => {
//             const [heading, ...rest] = item.split("\n");
//             return (
//               <View key={i} style={{ flex: 1, backgroundColor: i % 2 === 0 ? C.primary : C.purpleLight, borderRadius: 4, padding: 10 }}>
//                 <Text style={{ fontSize: 8.5, fontWeight: "bold", color: i % 2 === 0 ? C.accent : C.primary, marginBottom: 4, letterSpacing: 0.5 }}>{heading}</Text>
//                 <Text style={{ fontSize: 7.5, color: i % 2 === 0 ? "rgba(255,255,255,0.8)" : C.muted, lineHeight: 1.5 }}>{rest.join("\n")}</Text>
//               </View>
//             );
//           })}
//         </View>

//         <Footer location={loaction} proposalData={proposalData} />
//       </Page>

//       {/* ════════════════════════════════════════════════════════════════════
//           PAGE 4 — ABOUT ZITHAS
//       ════════════════════════════════════════════════════════════════════ */}
//       <Page size="A4" style={styles.page}>
//         <PageHeader proposalData={proposalData} />

//         <Text style={styles.sectionHeading}>About Zithas Technologies</Text>

//         <Text style={styles.para}>
//           Zithas Technologies is an IT service company with a team of dedicated experts across web design, CRM
//           development, ERP development, and full-stack web solutions. With over 12 years of industry experience, we
//           have helped businesses and organizations across India and beyond build powerful digital platforms that drive
//           real results.
//         </Text>

//         {/* Stats */}
//         <View style={styles.statsRow}>
//           {[["12+", "Years of Experience"], ["200+", "Projects Delivered"], ["50+", "Happy Clients"]].map(([num, label], i) => (
//             <View key={i} style={styles.statBox}>
//               <Text style={styles.statNumber}>{num}</Text>
//               <Text style={styles.statLabel}>{label}</Text>
//             </View>
//           ))}
//         </View>

//         {/* Vision */}
//         <View style={styles.highlightBox}>
//           <Text style={{ ...styles.highlightText, fontWeight: "bold", color: C.purple }}>Our Vision</Text>
//           <Text style={styles.highlightText}>
//             "Our Vision is our Inspiration. Assured quality and effective communication are the pillars we abide by."
//           </Text>
//         </View>

//         <Text style={{ fontSize: 10, color: C.primary, fontWeight: "bold", marginTop: 14, marginBottom: 6 }}>
//           From the Founder's Desk
//         </Text>
//         <Text style={styles.para}>
//           Being the founders, the sole purpose under which we work is keeping our clients happy and helping their
//           business flourish. We run with the motto "You Grow We Grow" and make sure that we align with our clients'
//           expectations.
//         </Text>
//         <Text style={styles.para}>
//           For us, Zithas is not just business — it is an opportunity to learn, to develop, and to achieve. It keeps us
//           motivated and inspires us to reach the top and be the best. Understanding what our clients want and offering
//           them what they expect is the overriding purpose of our company.
//         </Text>

//         {/* Founder image */}
//         <View style={{ flexDirection: "row", alignItems: "center", marginTop: 14, gap: 14 }}>
//           <Image style={{ width: 70, height: 90, objectFit: "cover", borderRadius: 4 }} src={JuliusSir} />
//           <View>
//             <Text style={{ fontSize: 11, color: C.primary, fontWeight: "bold" }}>Julius Gohil</Text>
//             <Text style={{ fontSize: 9, color: C.muted }}>Founder & Director</Text>
//             <Text style={{ fontSize: 9, color: C.muted }}>Zithas Technologies Pvt. Ltd.</Text>
//             <Text style={{ fontSize: 8.5, color: C.muted, marginTop: 6, fontStyle: "italic", maxWidth: 250 }}>
//               "We don't just build — we build digital futures for the organizations we believe in."
//             </Text>
//           </View>
//         </View>

//         {/* Why choose us */}
//         <Text style={{ ...styles.sectionHeading, marginTop: 20 }}>Why Choose Zithas Technologies?</Text>
//         <View style={styles.featureTable}>
//           <View style={styles.featureTableHeader}>
//             <Text style={{ ...styles.featureTableHeaderCell, width: "6%" }}>#</Text>
//             <Text style={{ ...styles.featureTableHeaderCell, width: "32%" }}>Strength</Text>
//             <Text style={{ ...styles.featureTableHeaderCell, flex: 1 }}>What It Means for {companyName}</Text>
//           </View>
//           {strengths.map((s, i) => (
//             <View key={i} style={[styles.strengthRow, i % 2 !== 0 && styles.featureRowAlt]}>
//               <Text style={styles.strengthNum}>{s.num}</Text>
//               <Text style={styles.strengthTitle}>{s.title}</Text>
//               <Text style={styles.strengthDesc}>{s.desc}</Text>
//             </View>
//           ))}
//         </View>

//         <Footer location={loaction} proposalData={proposalData} />
//       </Page>

//       {/* ════════════════════════════════════════════════════════════════════
//           PAGE 5 — THANK YOU / CLOSING
//       ════════════════════════════════════════════════════════════════════ */}
//       <Page size="A4" style={styles.page}>
//         <PageHeader proposalData={proposalData} />

//         <View style={{ flex: 1, justifyContent: "center" }}>
//           <View style={styles.thankYouBox}>
//             <Text style={styles.thankYouTitle}>Thank You</Text>
//             <Text style={{ color: C.accent, fontSize: 10, marginBottom: 10 }}>for the opportunity to present this proposal</Text>
//             <Text style={styles.thankYouSub}>
//               We look forward to partnering with {companyName} to build a world-class digital
//               platform that amplifies your mission, deepens stakeholder trust, and drives lasting impact.
//             </Text>

//             <View style={{ flexDirection: "row", gap: 12, width: "100%" }}>
//               {/* Submit To */}
//               <View style={[styles.contactCard, { flex: 1 }]}>
//                 <Text style={styles.contactLabel}>Submit Proposal To</Text>
//                 <Text style={{ ...styles.contactValue, fontWeight: "bold", fontSize: 10 }}>
//                   {proposalData?.contactname || ""}
//                 </Text>
//                 <Text style={styles.contactValue}>{proposalData?.email || ""}</Text>
//               </View>

//               {/* Our Contact */}
//               <View style={[styles.contactCard, { flex: 1 }]}>
//                 <Text style={styles.contactLabel}>Our Contact</Text>
//                 <Text style={{ ...styles.contactValue, fontWeight: "bold", fontSize: 10 }}>
//                   {proposalData?.contactmember || ""}
//                 </Text>
//                 <Text style={styles.contactValue}>{proposalData?.provideremail || ""}</Text>
//                 <Text style={styles.contactValue}>{proposalData?.contact || ""} | {proposalData?.website1 || ""}</Text>
//               </View>
//             </View>
//           </View>

//           {/* Company footer stamp */}
//           <View style={{ marginTop: 24, alignItems: "center" }}>
//             <View style={{ flexDirection: "row", height: 3, width: "60%", marginBottom: 10 }}>
//               <View style={{ flex: 3.5, backgroundColor: C.red }} />
//               <View style={{ flex: 1.5, backgroundColor: C.orange }} />
//               <View style={{ flex: 5, backgroundColor: C.green }} />
//             </View>
//             <Text style={{ fontSize: 9, color: C.primary, fontWeight: "bold", letterSpacing: 0.5 }}>
//               {loaction == 1 ? "ZITHAS TECHNOLOGIES PVT. LTD." : "ZITHAS TECHNOLOGIES LTD."}
//             </Text>
//             <Text style={{ fontSize: 8, color: C.muted, marginTop: 3 }}>
//               {loaction == 1 ? "Vadodara, Gujarat, India" : "United Kingdom"} | {proposalData?.website1 || "www.zithas.in"} | "You Grow We Grow"
//             </Text>
//           </View>
//         </View>

//         <Footer location={loaction} proposalData={proposalData} />
//       </Page>
//     </Document>
//   );
// };

// // ─── ProposalPdf Component ────────────────────────────────────────────────────
// const ProposalPdf = ({ proposal_id }) => {
//   const [viewData, setViewData] = useState(false);
//   const [proposalData, setProposalData] = useState({});
//   const [loaction, setLocation] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [allEmails, setAllEmails] = useState([]);

//   const FetchProposalData = async () => {
//     setLoading(true);
//     const formData = new FormData();
//     formData.append("proposal_id", proposal_id);

//     try {
//       const response = await axios({
//         method: "post",
//         url: `${configure.nodeApi}/view_proposal`,
//         data: formData,
//         headers: {
//           Accept: "application/json",
//           "Content-Type": "multipart/form-data",
//         },
//       });

//       const d = response.data.data[0];
//       setProposalData(d);
//       setLocation(d.location);

//       // ── Build email list ──
//       const emails = new Set();
//       if (d.provideremail) emails.add(d.provideremail);

//       if (d.related === "lead" && d.source_name && d.source_name !== "null") {
//         try {
//           const leadRes = await axios.get(
//             `${configure.nodeApi}/lead_emails?lead_id=${d.source_name}`,
//             { headers: { Accept: "application/json" } },
//           );
//           if (leadRes.data.success && Array.isArray(leadRes.data.data)) {
//             leadRes.data.data.forEach((email) => { if (email) emails.add(email); });
//           }
//         } catch (err) {
//           console.error("Failed to fetch lead emails:", err);
//         }
//       } else {
//         if (d.email) emails.add(d.email);
//       }

//       setAllEmails([...emails]);
//       setViewData(true);
//     } catch (err) {
//       console.error("FetchProposalData error:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <>
//       {loading && <Loader />}

//       <button
//         className="btn btn-sm btn-outline-secondary me-1"
//         onClick={FetchProposalData}
//         title="View Proposal PDF"
//       >
//         <i className="fa fa-file-pdf"></i>
//       </button>

//       <Modal size="xl" centered isOpen={viewData} className="modal-fullscreen">
//         <div className="modal-header">
//           <h5 className="modal-title mt-0">Proposal Preview</h5>
//           <div className="d-flex align-items-center ms-auto gap-2">
//             {/* Send Email */}
//             <button
//               className="btn btn-sm btn-outline-primary"
//               title="Send via Outlook"
//               onClick={() => {
//                 const to = encodeURIComponent(allEmails.join(";"));
//                 const subject = encodeURIComponent(proposalData?.proposaltitile || "Proposal");
//                 window.open(
//                   `https://outlook.cloud.microsoft/mail/deeplink/compose?to=${to}&subject=${subject}`,
//                   "_blank",
//                 );
//               }}
//             >
//               <i className="fa fa-envelope me-1"></i> Send Email
//               {allEmails.length > 0 && (
//                 <span className="badge bg-secondary ms-1">{allEmails.length}</span>
//               )}
//             </button>

//             {/* Close */}
//             <button
//               type="button"
//               onClick={() => setViewData(false)}
//               className="btn-modal-close"
//               style={{ marginTop: "8px" }}
//             >
//               <span aria-hidden="true" className="btn-modal-span">&times;</span>
//             </button>
//           </div>
//         </div>

//         <div className="modal-body p-0">
//           <PDFViewer width="100%" height="860px" style={{ border: "none" }}>
//             <MyProposalDocument loaction={loaction} proposalData={proposalData} />
//           </PDFViewer>
//         </div>
//       </Modal>
//     </>
//   );
// };

// export default ProposalPdf;

import React, { useState } from "react";
import { Modal } from "reactstrap";
import {
  Document,
  Page,
  Image,
  Text,
  StyleSheet,
  PDFViewer,
  View,
  Font,
} from "@react-pdf/renderer";
import zithasLogo from "../../../assets/images/zithas-dark-logo.png";
import JuliusSir from "../../../assets/images/julius.png";
import axios from "axios";
import configure from "configure";
import moment from "moment";
import Loader from "pages/Separate/Loader";
import GenerateEmailModal from "./GenerateEmailModal";

const C = {
  navy: "#1a1a5e",
  purple: "#5b2d8e",
  purpleLight: "#ede4f5",
  gold: "#FFB343",
  text: "#333333",
  muted: "#555555",
  border: "#cccccc",
  tableAlt: "#eeeef7",
  white: "#ffffff",
  red: "#850505",
  orange: "#fea200",
  green: "#7cfe00",
  blueLight: "#EEF2F7"
};

const S = StyleSheet.create({
  page: {
    paddingTop: 30,
    paddingBottom: 50,
    paddingHorizontal: 30,
    backgroundColor: C.white,
    fontSize: 9,
    color: C.text,
  },
  topBar: {
    flexDirection: "row",
    color: C.purple,
    justifyContent: "space-between",
    alignItems: "center",
    borderBottomWidth: 1,
    borderBottomColor: C.purple,
    paddingBottom: 4,
    marginBottom: 10,
  },
  topBarLeft: { fontSize: 8.5, color: C.muted },
  topBarRight: { fontSize: 8.5, color: C.purple, fontFamily: "Helvetica-Bold" },
  footer: { position: "absolute", bottom: 16, left: 30, right: 30 },
  footerLine: {
    flexDirection: "row",
    justifyContent: "space-between",
    borderTopWidth: 1,
    borderTopColor: C.purple,
    paddingTop: 5,
  },
  footerText: { fontSize: 7, color: C.muted },
  coverLogo: {
    width: 200,
    alignSelf: "center",
    marginTop: 20,
    marginBottom: 4,
  },
  coverTagline: {
    fontSize: 11,
    color: C.gold,
    textAlign: "center",
    marginBottom: 20,
  },
  coverDivider: { height: 2, backgroundColor: C.purple, marginBottom: 20 },
  coverTitle: {
    fontSize: 18,
    color: C.navy,
    textAlign: "center",
    fontFamily: "Helvetica-Bold",
    fontWeight: "bold",
    marginBottom: 4,
  },
  coverSubtitle: {
    fontSize: 12,
    color: C.muted,
    textAlign: "center",
    marginBottom: 15,
  },
  infoTablesRow: {
    flexDirection: "row",
    gap: 12,
    marginBottom: 20,
    paddingHorizontal: 20,
  },
  infoTable: { flex: 1, borderWidth: 1, borderColor: C.border },
  infoTableHeader: {
    backgroundColor: C.navy,
    paddingVertical: 5,
    paddingHorizontal: 8,
  },
  infoTableHeader2: {
    backgroundColor: C.purple,
    paddingVertical: 5,
    paddingHorizontal: 8,
  },
  infoTableHeaderText: {
    color: C.white,
    fontSize: 11,
    fontFamily: "Helvetica-Bold",
    fontWeight: "bold",
    textAlign: "center",
    letterSpacing: 0.5,
  },
  infoRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: C.border,
  },
  infoLabel: {
    width: "35%",
    paddingVertical: 4,
    paddingHorizontal: 6,
    fontSize: 9,
    color: C.navy,
    fontWeight: "bold",
  },
  infoValue: {
    flex: 1,
    paddingVertical: 4,
    paddingHorizontal: 6,
    fontSize: 9,
    color: C.text,
  },
  coverNote: {
    fontSize: 10,
    color: C.muted,
    textAlign: "center",
    fontFamily: "Helvetica-Oblique",
    lineHeight: 1.5,
  },
  sectionHeadingDark: {
    backgroundColor: C.navy,
    paddingVertical: 5,
    paddingHorizontal: 8,
    marginBottom: 10,
  },
  sectionHeadingDark2: {
    backgroundColor: C.purple,
    paddingVertical: 5,
    paddingHorizontal: 8,
    marginBottom: 10,
  },
  sectionHeadingDarkText: {
    color: C.white,
    fontSize: 10,
    fontFamily: "Helvetica-Bold",
    letterSpacing: 0.5,
  },
  sectionUnder: {
    borderBottomWidth: 1,
    borderBottomColor: C.navy,
    paddingBottom: 3,
    marginBottom: 8,
    marginTop: 12,
  },
  sectionUnderText: {
    fontSize: 12,
    color: C.purple,
    fontWeight: "bold",
    fontFamily: "Helvetica-Bold",
  },
  table: { borderWidth: 1, borderColor: C.border, marginBottom: 12 },
  tableHeaderRow: { flexDirection: "row", backgroundColor: C.navy },
  tableHeaderCell: {
    color: C.white,
    fontSize: 10,
    fontFamily: "Helvetica-Bold",
    paddingVertical: 5,
    paddingHorizontal: 6,
  },
  tableRow: {
    flexDirection: "row",
    borderTopWidth: 1,
    borderTopColor: C.border,
  },
  tableRowAlt: { backgroundColor: C.tableAlt },
  tableCell: {
    fontSize: 8,
    paddingVertical: 5,
    paddingHorizontal: 6,
    color: C.text,
    borderRightWidth: 1,
    borderRightColor: C.border,
  },
  tableCellBold: {
    fontSize: 8,
    paddingVertical: 5,
    paddingHorizontal: 6,
    color: C.navy,
    fontWeight: "bold",
    fontFamily: "Helvetica-Bold",
    backgroundColor: C.purpleLight,
    borderRightWidth: 1,
    borderRightColor: C.border,
  },
  para: { fontSize: 10, color: C.text, lineHeight: 1.6, marginBottom: 2 },
  paraBold: {
    fontSize: 10,
    color: C.navy,
    fontWeight: "bold",
    marginBottom: 4,
    marginTop: 8,
  },
  bulletRow: { flexDirection: "row", marginBottom: 3, paddingLeft: 8 },
  bullet: { fontSize: 8.5, color: C.text, marginRight: 5 },
  bulletText: { fontSize: 10, color: C.text, lineHeight: 1, flex: 1 },
  statsRow: { flexDirection: "row", gap: 10, marginVertical: 10 },
  statBox: {
    flex: 1,
    backgroundColor: C.purpleLight,
    paddingVertical: 10,
    alignItems: "center",
    borderRadius: 3,
  },
  statNum: { fontSize: 18, color: C.purple, fontFamily: "Helvetica-Bold" },
  statLabel: { fontSize: 9, color: C.navy, marginTop: 2 },
  founderBox: {
    borderWidth: 1,
    borderColor: C.border,
    padding: 10,
    marginTop: 10,
  },
  founderName: { fontSize: 9, color: C.navy, fontWeight: "bold" },
  founderTitle: { fontSize: 8, color: C.purple, marginBottom: 4 },
  founderQuote: { fontSize: 8, color: C.muted, fontStyle: "italic" },
  tyTitle: {
    fontSize: 30,
    color: C.navy,
    textAlign: "center",
    fontWeight: "bold",
    marginBottom: 6,
    marginTop: 40,
    fontFamily: "Helvetica-Bold",
  },
  tySub: {
    fontSize: 14,
    color: C.purple,
    textAlign: "center",
    marginBottom: 16,
  },
  tyContactRow: { flexDirection: "row", gap: 16, marginTop: 16 },
  tyContactBox: {
    flex: 1,
    borderWidth: 1,
    borderColor: C.border,
    padding: 10,
    overflow: "hidden",
  },
  tyContactLabel: {
    fontSize: 8,
    color: C.navy,
    fontWeight: "bold",
    marginBottom: 4,
  },
  tyContactValue: { fontSize: 8, color: C.text, lineHeight: 1.2 },
  tyStamp: { marginTop: 30, alignItems: "center" },
  tyStampName: {
    fontSize: 9,
    color: C.navy,
    fontWeight: "bold",
    letterSpacing: 0.5,
  },
  tyStampSub: { fontSize: 7.5, color: C.muted, marginTop: 2 },
  colorBar: { flexDirection: "row", height: 4, marginTop: 6 },
});

// ── Register fonts ──────────────────────────────────────────────────────────
Font.register({
  family: "NotoSans",
  fonts: [
    {
      src: "https://fonts.gstatic.com/s/notosans/v36/o-0IIpQlx3QUlC5A4PNb4j5Ba_2c7A.ttf",
      fontWeight: "normal",
    },
    {
      src: "https://fonts.gstatic.com/s/notosans/v36/o-0HqpQlx3QUlC5A4PNb4hRJkqoSeA.ttf",
      fontWeight: "bold",
    },
  ],
});

const TopBar = ({ location }) => (
  <View style={S.topBar} fixed>
    <Text style={S.topBarLeft}>
      {location == 1
        ? "Zithas Technologies Pvt. Ltd."
        : "Zithas Technologies Ltd."}{" "}
      | Website Development Proposal
    </Text>
    <Text style={S.topBarRight}>Confidential</Text>
  </View>
);

const Footer = ({ email, website, phone }) => (
  <View style={S.footer} fixed>
    <View style={S.footerLine}>
      <Text style={S.footerText}>
        {email} | {website} | {phone}
      </Text>
      <Text
        style={S.footerText}
        render={({ pageNumber }) => `Page ${pageNumber}`}
      />
    </View>
  </View>
);

const ColorBar = () => (
  <View style={S.colorBar}>
    <View style={{ flex: 3.5, backgroundColor: C.red }} />
    <View style={{ flex: 1.5, backgroundColor: C.orange }} />
    <View style={{ flex: 5, backgroundColor: C.green }} />
  </View>
);

const DarkHeading = ({ text }) => (
  <View style={S.sectionHeadingDark}>
    <Text style={S.sectionHeadingDarkText}>{text}</Text>
  </View>
);

const DarkHeading2 = ({ text }) => (
  <View style={S.sectionHeadingDark2}>
    <Text style={S.sectionHeadingDarkText}>{text}</Text>
  </View>
);

const UnderHeading = ({ text }) => (
  <View style={S.sectionUnder}>
    <Text style={S.sectionUnderText}>{text}</Text>
  </View>
);

const Bullet = ({ text }) => (
  <View style={S.bulletRow}>
    <Text style={S.bullet}>•</Text>
    <Text style={S.bulletText}>{text}</Text>
  </View>
);

const Check = ({ text }) => (
  <View style={S.bulletRow}>
    <Text style={[S.bullet, { fontFamily: "NotoSans" }]}>•</Text>
    {/* <Text style={[S.bullet, { fontFamily: "ZapfDingbats", fontSize: 7 }]}>4</Text> */}
    {/* <Text style={[S.bullet, { fontFamily: "Symbol" }]}>✓</Text> */}
    <Text style={S.bulletText}>{text}</Text>
  </View>
);

  const FeatureTable = ({ rows }) => (
    <View style={S.table}>
      <View style={S.tableHeaderRow}>
        <Text style={[S.tableHeaderCell, { width: "6%" }]}>#</Text>
        <Text style={[S.tableHeaderCell, { width: "26%" }]}>Page / Module</Text>
        <Text style={[S.tableHeaderCell, { flex: 1 }]}>
          Key Features & Elements
        </Text>
      </View>
      {rows.map((f, i) => (
        // <View key={i} style={[S.tableRow, i % 2 !== 0 && S.tableRowAlt]}>
        <View key={i} style={[S.tableRow]}>
          <Text
            style={[
              S.tableCell,
              {
                width: "6%",
                backgroundColor: C.purpleLight,
                color: C.navy,
                fontSize: 10,
              },
            ]}
          >
            {f.num}
          </Text>
          <Text
            style={[S.tableCell, { width: "26%", color: C.navy, fontSize: 10, backgroundColor: C.blueLight }]}
          >
            {f.title}
          </Text>
          <View style={{ flex: 1, paddingVertical: 4, paddingHorizontal: 6 }}>
            {f.items.map((item, j) => (
              <Check key={j} text={item} />
            ))}
          </View>
        </View>
      ))}
    </View>
  );

const MyProposalDocument = ({ loaction, proposalData, rfpData }) => {
  const companyName = proposalData?.companyname || "the Client";
  const title = proposalData?.proposaltitile || "Website Development Proposal";
  const providerEmail = proposalData?.provideremail || "";
  const providerWebsite = proposalData?.website1 || "www.zithas.in";
  const providerPhone = proposalData?.contact || "";
  // Derive investment figures from RFP costing
  const rfpCosting = rfpData;
  const currencySymbol = rfpCosting?.currency_symbol || "";
  const grandTotal = rfpCosting?.grand_total || null;
  const vatPct = rfpCosting?.vat?.pct || null;
  const vatAmount = rfpCosting?.vat?.amount || null;
  const subTotalBeforeVat =
    grandTotal && vatAmount ? (grandTotal - vatAmount).toFixed(2) : null;

  const termsData = (() => {
    try {
      const raw = proposalData?.terms;
      return typeof raw === "string" ? JSON.parse(raw) : raw || [];
    } catch {
      return [];
    }
  })();

  const projectObjectiveText = proposalData?.project_objective || "";

  const termsDuration = termsData[0]?.value || termsData[0]?.total || "";
  const termsCost1 =
    parseFloat(termsData[1]?.value || termsData[1]?.total || 0) || 0;
  const termsCost2 =
    parseFloat(termsData[2]?.value || termsData[2]?.total || 0) || 0;
  const termsTotal = termsCost1 + termsCost2;
  const termsCurrSym = termsData[1]?.currency || currencySymbol || "";

  const clientInfo = [
    { label: "Company:", value: proposalData?.companyname },
    { label: "Contact:", value: proposalData?.contactname },
    { label: "Address:", value: proposalData?.address },
    { label: "Phone:", value: proposalData?.cilentcontact },
    { label: "Email:", value: proposalData?.email },
    { label: "Website:", value: proposalData?.website },
  ];

  const providerInfo = [
    {
      label: "Company:",
      value:
        proposalData?.company2 ||
        (loaction == 1
          ? "Zithas Technologies Pvt. Ltd."
          : "Zithas Technologies Ltd."),
    },
    { label: "Contact:", value: proposalData?.contactmember },
    { label: "Address:", value: proposalData?.address1 },
    { label: "Phone:", value: proposalData?.contact },
    { label: "Email:", value: proposalData?.provideremail },
    { label: "Website:", value: proposalData?.website1 },
  ];

  // const features = [
  //   {
  //     num: "1",
  //     title: "Website Transformation",
  //     items: [
  //       "Modern, clean, and professional visual interface.",
  //       "Dynamic hero banner with compelling value proposition.",
  //       "Strategically placed Call-to-Action (CTA) buttons.",
  //       "Clear industry-focused positioning",
  //       "Structured content layout for enhanced readability and engagement",
  //     ],
  //   },
  //   {
  //     num: "2",
  //     title: "Full Responsive Framework",
  //     items: [
  //       "Optimized experience across desktop, tablet, and mobile devices.",
  //       "Cross-browser compatibility assurance (Chrome, Firefox, Safari, Edge)",
  //       "Mobile-first design approach",
  //       "Touch-friendly navigation and UI elements",
  //       "Performance optimization for smooth user experience",
  //     ],
  //   },
  //   {
  //     num: "3",
  //     title: "Engagement & Animation Elements",
  //     items: [
  //       "Subtitle section transition effects",
  //       "Hover interactions",
  //       "Animated icons and graphics",
  //       "Interactive backgrounds (where applicable)",
  //     ],
  //   },
  //   {
  //     num: "4",
  //     title: "User Account & Authentication",
  //     items: [
  //       "User registration, login, logout",
  //       "Password reset via email",
  //       "Profile management (address book, order history)",
  //       "Wishlist & saved items",
  //     ],
  //   },
  //   {
  //     num: "5",
  //     title: "Product Page",
  //     items: [
  //       "Clean listing page with filters & search",
  //       "Multiple product images & zoom",
  //       "Product variants (size, color, quantity)",
  //       "Stock availability indicator",
  //       "Related products",
  //       "CTA buttons",
  //     ],
  //   },
  //   {
  //     num: "6",
  //     title: "Shopping Cart & Checkout",
  //     items: [
  //       "Add/remove/update cart items",
  //       "Save cart for later",
  //       "Guest checkout option",
  //       "Order summary",
  //     ],
  //   },
  //   {
  //     num: "7",
  //     title: "Order Management",
  //     items: [
  //       "Order confirmation email",
  //       "Real-time order tracking",
  //       "Order history & invoice download",
  //       "Return/refund request",
  //       "Cancellation before dispatch",
  //     ],
  //   },
  //   {
  //     num: "8",
  //     title: "Payment Integration",
  //     items: [
  //       "Integration with secure payment gateways and cash on delivery",
  //       "Real-time payment status updates with order confirmation on successful transactions",
  //       "Secure checkout with payment processing",
  //       "Easy refund and cancellation management with transaction",
  //     ],
  //   },
  //   {
  //     num: "9",
  //     title: "Contact Page",
  //     items: [
  //       "Contact form (name, email, phone, message)",
  //       "Office address with Google Maps embed",
  //       "Business hours display",
  //     ],
  //   },
  //   {
  //     num: "10",
  //     title: "Blog Management",
  //     items: [
  //       "Blog listing page",
  //       "Blog detail page",
  //       "Categories & tags",
  //       "Related posts",
  //     ],
  //   },
  //   {
  //     num: "11",
  //     title: "SEO Optimization",
  //     items: [
  //       "SEO-friendly URL structure",
  //       "Meta title & description support",
  //       "Image optimization",
  //       "Page speed optimization",
  //     ],
  //   },
  //   {
  //     num: "12",
  //     title: "Accessibility (WCAG Compliance)",
  //     items: [
  //       "Proper heading hierarchy",
  //       "Alt tags for images",
  //       "Color contrast compliance",
  //       "Accessible forms and button",
  //     ],
  //   },
  //   {
  //     num: "13",
  //     title: "Dashboard",
  //     items: [
  //       "Sales overview (daily/weekly/monthly)",
  //       "Revenue charts & graphs",
  //       "Top-selling products",
  //       "Recent orders & alerts",
  //       "Low stock notifications",
  //     ],
  //   },
  //   {
  //     num: "14",
  //     title: "Product Management",
  //     items: [
  //       "Add/edit/delete products",
  //       "Category & subcategory management",
  //       "Inventory/stock management",
  //       "Product variants & SKU management",
  //       "Image upload & management",
  //     ],
  //   },
  //   {
  //     num: "15",
  //     title: "Order Management (Admin)",
  //     items: [
  //       "View & filter all orders",
  //       "Update order status",
  //       "Generate invoices",
  //       "Manage returns & refunds",
  //     ],
  //   },
  //   {
  //     num: "16",
  //     title: "Customer Management",
  //     items: [
  //       "View customer profiles & purchase history",
  //       "Block/unblock users",
  //     ],
  //   },
  //   {
  //     num: "17",
  //     title: "Reports & Analytics",
  //     items: [
  //       "Sales reports (by product, category, region)",
  //       "Inventory reports",
  //       "Payment & transaction reports",
  //       "Export reports to PDF",
  //     ],
  //   },
  //   {
  //     num: "18",
  //     title: "Content Management",
  //     items: ["Blog management", "Terms, Privacy Policy, Return Policy pages"],
  //   },
  // ];

  // const phases = [
  //   { num: "1", title: "Discovery & Strategy", duration: "Wk 1", desc: "Requirement spec, user personas, content plan" },
  //   { num: "2", title: "UI/UX Design", duration: "Wk 2–3", desc: "Design system" },
  //   { num: "3", title: "Development", duration: "Wk 3–7", desc: "Admin, all core pages" },
  //   { num: "4", title: "Content Integration", duration: "Wk 7–8", desc: "Upload, format, SEO-optimize all client content" },
  //   { num: "5", title: "QA & Testing", duration: "Wk 8", desc: "Functional, accessibility, performance, security tests" },
  //   { num: "6", title: "Deployment", duration: "Wk 8", desc: "Go-live, SSL" },
  // ];
  // In MyProposalDocument — replace the hardcoded phases const:
  // ── Build feature rows from RFP data (only when RFP exists) ──
  const rfpFeatureRows = (() => {
    if (!rfpData?.features || !Array.isArray(rfpData.features)) return [];
    const rows = [];
    rfpData.features.forEach((svc, svcIdx) => {
      (svc.subtitles || []).forEach((sub, subIdx) => {
        rows.push({
          num: String(rows.length + 1),
          title: sub.title || "",
          items: (sub.features || []).map((f) => f.title || "").filter(Boolean),
        });
      });
    });
    return rows;
  })();

  const hasRfpFeatures = rfpFeatureRows.length > 0;

  // ── Compute feature page chunks BEFORE return ──
const featureOverflowChunks = (() => {
  if (!hasRfpFeatures || rfpFeatureRows.length <= 5) return [];
  const remaining = rfpFeatureRows.slice(5);
  const chunks = [];
  for (let i = 0; i < remaining.length; i += 12) {
    chunks.push(remaining.slice(i, i + 12));
  }
  return chunks;
})();

  const phases = (() => {
    try {
      const saved =
        typeof proposalData?.timeline === "string"
          ? JSON.parse(proposalData.timeline)
          : proposalData?.timeline;
      if (Array.isArray(saved)) {
        return saved.map((p, i) => ({
          num: String(i + 1),
          title: p.phase || "",
          duration: p.duration ? `Wk ${p.duration}` : "",
          desc: p.deliverables || "",
        }));
      }
    } catch {}
    return [];
  })();

  const milestones = [
    { milestone: "Advance", pct: "50 %", trigger: "Agreement executed" },
    {
      milestone: "50% of completion of project",
      pct: "30 %",
      trigger: "50% Development completed",
    },
    {
      milestone: "100% of completion of project",
      pct: "20 %",
      trigger: "Production deployment",
    },
  ];

  const techFeatures = [
    "Fully responsive, mobile-first design",
    "WCAG 2.1 AA accessibility compliance",
    "SSL / HTTP",
    "Cross-browser (Chrome, Firefox, Safari, Edge)",
  ];

  const strengths = [
    {
      num: "1",
      title: "12+ Years of Expertise",
      desc: "Deep technical capability built over a decade — not a start-up experimenting on your project",
    },
    {
      num: "2",
      title: "Nonprofit & Foundation Experience",
      desc: "We understand the storytelling, transparency, and stakeholder needs unique to foundations",
    },
    {
      num: "3",
      title: "End-to-End Delivery",
      desc: "Strategy to Launch to Support — one team, one contact, zero handoff gaps",
    },
    {
      num: "4",
      title: "Accessibility by Default",
      desc: "Every site meets WCAG 2.1 AA — built in, not bolted on",
    },
    {
      num: "5",
      title: "Performance-Obsessed",
      desc: "Our builds consistently achieve 90+ on Google Lighthouse",
    },
    {
      num: "6",
      title: "Transparent Pricing",
      desc: "No hidden costs — milestone-based payments, full disclosure before work begins",
    },
    {
      num: "7",
      title: "Post-Launch Partnership",
      desc: "AMC/retainer plans ensure your site stays current and supported long after go-live",
    },
    {
      num: "8",
      title: "Vadodara-Based, India-Aligned",
      desc: "Same time zone, direct communication, on-site visits possible",
    },
  ];



  return (
    <Document>
      {/* PAGE 1 — COVER */}
      <Page size="A4" style={S.page}>
        <TopBar location={loaction} />
        {/* <Image style={S.coverLogo} src={zithasLogo} /> */}
        <View style={{ alignItems: "center", marginTop: 20, marginBottom: 4 }}>
          <Text
            style={{
              fontSize: 36,
              color: C.navy,
              fontFamily: "Helvetica-Bold",
              letterSpacing: 1,
            }}
          >
            ZITHAS
          </Text>
          <Text
            style={{
              fontSize: 22,
              color: C.purple,
              fontFamily: "Helvetica-Bold",
              letterSpacing: 0.5,
            }}
          >
            TECHNOLOGIES
          </Text>
        </View>
        <Text style={S.coverTagline}>You Grow | We Grow</Text>
        <View style={S.coverDivider} />
        <Text style={S.coverTitle}>{title}</Text>
        <Text style={S.coverSubtitle}>Prepared for {companyName}</Text>
        <View style={S.infoTablesRow}>
          <View style={S.infoTable}>
            <View style={S.infoTableHeader}>
              <Text style={S.infoTableHeaderText}>CLIENT INFORMATION</Text>
            </View>
            {clientInfo.map((row, i) => (
              <View
                key={i}
                style={[
                  S.infoRow,
                  i % 2 !== 0 && { backgroundColor: C.tableAlt },
                ]}
              >
                <Text style={S.infoLabel}>{row.label}</Text>
                <Text style={S.infoValue}>
                  {row.value && row.value !== "null" ? row.value : "-"}
                </Text>
              </View>
            ))}
          </View>
          <View style={S.infoTable}>
            <View style={S.infoTableHeader2}>
              <Text style={S.infoTableHeaderText}>PROVIDER INFORMATION</Text>
            </View>
            {providerInfo.map((row, i) => (
              <View
                key={i}
                style={[
                  S.infoRow,
                  i % 2 !== 0 && { backgroundColor: C.tableAlt },
                ]}
              >
                <Text style={S.infoLabel}>{row.label}</Text>
                <Text style={S.infoValue}>
                  {row.value && row.value !== "null" ? row.value : "-"}
                </Text>
              </View>
            ))}
          </View>
        </View>
        <Text style={S.coverNote}>
          Zithas Technologies is pleased to present this proposal to{" "}
          {companyName} for the design,{"\n"}
          development, and deployment of a professional corporate website
          aligned with your mission and digital goals.
        </Text>
        <Footer
          email={providerEmail}
          website={providerWebsite}
          phone={providerPhone}
        />
      </Page>

      {/* PAGE 2 — PROJECT INFO + FEATURES (1-5) */}
      <Page size="A4" style={S.page}>
        <TopBar location={loaction} />
        <DarkHeading text="PROJECT INFORMATION" />
        <View style={S.table}>
          {[
            {
              label: "Project Title",
              value: `${proposalData?.proposaltitile}`,
            },
            {
              label: "Proposed Go-Live",
              value: `~${termsDuration} from contract signing`,
            },
            {
              label: "Engagement Model",
              value: "Fixed-scope project with optional AMC retainer",
            },
            {
              label: "Primary Contact",
              value: `${
                proposalData?.contactmember || ""
              } – ${providerEmail} - ${providerPhone}`,
            },
          ].map((row, i) => (
            <View
              key={i}
              style={[S.tableRow, i === 0 && { borderTopWidth: 0 }]}
            >
              <Text style={[S.tableCellBold, { width: "28%", fontSize: 9 }]}>
                {row.label}
              </Text>
              <Text style={[S.tableCell, { flex: 1, fontSize: 9 }]}>{row.value}</Text>
            </View>
          ))}
        </View>

        <UnderHeading text="Project Objective" />
        {projectObjectiveText ? (
          // Dynamic: split by newline, render each line
          projectObjectiveText.split("\n").map((line, i) => {
            const trimmed = line.trim();
            if (!trimmed) return null;
            if (trimmed.startsWith("•")) {
              return <Bullet key={i} text={trimmed.slice(1).trim()} />;
            }
            return (
              <Text key={i} style={S.para}>
                {trimmed}
              </Text>
            );
          })
        ) : (
          // Static fallback if no AI text
          <>
            <Text style={S.para}>
              <Text style={{ fontFamily: "Helvetica-Oblique" }}>
                {companyName}
              </Text>{" "}
              requires a scalable, secure digital platform that:
            </Text>
            {[
              "Establishes a strong, trustworthy online storefront that enhances brand credibility and customer confidence",
              "Showcases products with clear descriptions, high-quality visuals, pricing, and availability",
              "Delivers a seamless shopping experience with intuitive navigation and mobile-friendly UX",
              "Enables secure and efficient checkout with multiple payment gateway integrations",
              "Ensures high-level security for transactions, customer data, and compliance standards",
            ].map((b, i) => (
              <Bullet key={i} text={b} />
            ))}
          </>
        )}

        {/* <UnderHeading text="Project Objective" />
        <Text style={S.para}>
          <Text style={{ fontFamily: "Helvetica-Oblique" }}>{companyName}</Text>{" "}
          requires a scalable, secure digital platform that:
        </Text>
        {[
          "Establishes a strong, trustworthy online storefront that enhances brand credibility and customer confidence",
          "Showcases products with clear descriptions, high-quality visuals, pricing, and availability",
          "Delivers a seamless shopping experience with intuitive navigation and mobile-friendly UX",
          "Enables secure and efficient checkout with multiple payment gateway integrations",
          "Ensures high-level security for transactions, customer data, and compliance standards",
        ].map((b, i) => (
          <Bullet key={i} text={b} />
        ))} */}

        {hasRfpFeatures && (
          <View style={{ marginTop: 12 }}>
            <DarkHeading2 text="FEATURE LIST" />

            <UnderHeading text="Core Pages — Included as Standard" />
            <FeatureTable rows={rfpFeatureRows} />
          </View>
        )}

        <UnderHeading text="Technical & Platform Features" />
        <View style={S.table}>
          <View style={S.tableHeaderRow}>
            <Text style={[S.tableHeaderCell, { width: "60%" }]}>Feature</Text>
            <Text style={[S.tableHeaderCell, { flex: 1 }]}>Status</Text>
          </View>
          {techFeatures.map((f, i) => (
            <View key={i} style={[S.tableRow]}>
              <Text style={[S.tableCell, { width: "60%", fontSize: 9 }]}>{f}</Text>
              <Text
                style={[
                  S.tableCell,
                  { flex: 1, color: C.navy, backgroundColor: C.purpleLight, fontSize: 9 },
                ]}
              >
                ✓ Included
              </Text>
            </View>
          ))}
        </View>
        <Footer
          email={providerEmail}
          website={providerWebsite}
          phone={providerPhone}
        />
      </Page>


      {/* PAGE 3 — TECH FEATURES + TIMELINE + COST */}
      <Page size="A4" style={S.page}>
        <TopBar location={loaction} />
        {/* <UnderHeading text="Technical & Platform Features" />
        <View style={S.table}>
          <View style={S.tableHeaderRow}>
            <Text style={[S.tableHeaderCell, { width: "60%" }]}>Feature</Text>
            <Text style={[S.tableHeaderCell, { flex: 1 }]}>Status</Text>
          </View>
          {techFeatures.map((f, i) => (
            <View key={i} style={[S.tableRow]}>
              <Text style={[S.tableCell, { width: "60%", fontSize: 9 }]}>{f}</Text>
              <Text
                style={[
                  S.tableCell,
                  { flex: 1, color: C.navy, backgroundColor: C.purpleLight, fontSize: 9 },
                ]}
              >
                ✓ Included
              </Text>
            </View>
          ))}
        </View> */}

        <View style={{ marginTop: 10 }}>
          <DarkHeading text="TIMELINE & COST" />
        </View>

        {phases.length > 0 && (
          <>
            <UnderHeading style={S.paraBold} text= "Project Timeline (~8 Weeks)"/>
            <View style={S.table}>
              <View style={S.tableHeaderRow}>
                <Text style={[S.tableHeaderCell, { width: "38%" }]}>Phase</Text>
                <Text style={[S.tableHeaderCell, { width: "16%" }]}>
                  Duration
                </Text>
                <Text style={[S.tableHeaderCell, { flex: 1 }]}>
                  Key Deliverables
                </Text>
              </View>
              {phases.map((p, i) => (
                <View key={i} style={[S.tableRow]}>
                  <Text
                    style={[
                      S.tableCell,
                      { width: "38%", backgroundColor: C.purpleLight, fontSize: 9, color: C.navy },
                    ]}
                  >
                    {p.num}. {p.title}
                  </Text>
                  <Text style={[S.tableCell, { width: "16%", fontSize: 9, backgroundColor: C.blueLight, color: C.navy} ]}>
                    {p.duration}
                  </Text>
                  <Text style={[S.tableCell, { flex: 1, fontSize: 9 }]}>{p.desc}</Text>
                </View>
              ))}
            </View>
          </>
        )}

        {/* <Text style={S.paraBold}>Project Investment</Text>
        <View style={S.table}>
          <View style={S.tableHeaderRow}>
            <Text style={[S.tableHeaderCell, { flex: 1 }]}>Description</Text>
            <Text style={[S.tableHeaderCell, { width: "40%" }]}>Price</Text>
          </View>
          <View style={S.tableRow}>
            <Text style={[S.tableCell, { flex: 1 }]}>{title}</Text>
            <Text style={[S.tableCell, { width: "40%", color: C.muted }]}>
              As per agreement
            </Text>
          </View>
          <View style={[S.tableRow, { backgroundColor: "#f0f0f8" }]}>
            <Text style={[S.tableCellBold, { flex: 1 }]}>
              Total Project Cost
            </Text>
            <Text style={[S.tableCellBold, { width: "40%" }]}>
              As per agreement
            </Text>
          </View>
        </View> */}
        <UnderHeading style={S.paraBold} text="Project Investment"/>
        <View style={S.table}>
          <View style={S.tableHeaderRow}>
            <Text style={[S.tableHeaderCell, { flex: 1 }]}>Description</Text>
            <Text style={[S.tableHeaderCell, { width: "40%" }]}>Amount</Text>
          </View>

          <View style={S.tableRow}>
            <Text style={[S.tableCell, { flex: 1, fontSize: 9 }]}>{title}</Text>
            <Text style={[S.tableCell, { width: "40%", color: C.muted, fontSize: 9 }]}>
              {subTotalBeforeVat
                ? `${currencySymbol}${Number(subTotalBeforeVat).toLocaleString(
                    "en-GB",
                    { minimumFractionDigits: 2 },
                  )}`
                : "As per agreement"}
            </Text>
          </View>

          {/* Row 3 — Domain/Hosting/SSL (only if value exists) */}
  {(termsData[2]?.value || termsData[2]?.total) ? (
    <View style={S.tableRow}>
      <Text style={[S.tableCell, { flex: 1, fontSize: 9 }]}>
        {termsData[2]?.service || "Domain, Hosting, and SSL (Annual Charges)"}
      </Text>
      <Text style={[S.tableCell, { width: "40%", color: C.muted, fontSize: 9 }]}>
        {`${termsCurrSym}${Number(termsData[2]?.value || termsData[2]?.total).toLocaleString("en-GB", { minimumFractionDigits: 2 })}`}
      </Text>
    </View>
  ) : null}

          {vatPct && vatAmount ? (
            <View style={S.tableRow}>
              <Text style={[S.tableCell, { flex: 1, color: C.muted, fontSize: 9 }]}>
                VAT ({vatPct}%)
              </Text>
              <Text style={[S.tableCell, { width: "40%", color: C.muted, fontSize: 9 }]}>
                {currencySymbol}
                {Number(vatAmount).toLocaleString("en-GB", {
                  minimumFractionDigits: 2,
                })}
              </Text>
            </View>
          ) : null}

          <View style={[S.tableRow, { backgroundColor: "#f0f0f8" }]}>
            <Text style={[S.tableCellBold, { flex: 1 , fontSize: 9}]}>
              Total Project Cost
            </Text>
            {/* <Text style={[S.tableCellBold, { width: "40%", fontSize: 9 }]}>
              {grandTotal
                ? `${currencySymbol}${Number(grandTotal).toLocaleString(
                    "en-GB",
                    { minimumFractionDigits: 2 },
                  )}${vatPct ? ` (inc. ${vatPct}% VAT)` : ""}`
                : "As per agreement"}
            </Text> */}
            <Text style={[S.tableCellBold, { width: "40%", fontSize: 9 }]}>
      {(() => {
        const cost1 = parseFloat(termsData[1]?.value || termsData[1]?.total || 0) || 0;
        const cost2 = parseFloat(termsData[2]?.value || termsData[2]?.total || 0) || 0;
        const vat   = parseFloat(vatAmount || 0) || 0;
        const total = cost1 + cost2 + vat;
        return total > 0
          ? `${termsCurrSym}${total.toLocaleString("en-GB", { minimumFractionDigits: 2 })}${vatPct ? ` (inc. ${vatPct}% VAT)` : ""}`
          : "As per agreement";
      })()}
    </Text>
          </View>
        </View>

        <Text style={S.paraBold}>Payment Milestones</Text>
        <View style={S.table}>
          <View style={S.tableHeaderRow}>
            <Text style={[S.tableHeaderCell, { flex: 1 }]}>Milestone</Text>
            <Text style={[S.tableHeaderCell, { width: "18%" }]}>Payment %</Text>
            <Text style={[S.tableHeaderCell, { width: "36%" }]}>Trigger</Text>
          </View>
          {milestones.map((m, i) => (
            <View key={i} style={[S.tableRow, i % 2 !== 0 && S.tableRowAlt]}>
              <Text style={[S.tableCell, { flex: 1, fontSize: 9 }]}>{m.milestone}</Text>
              <Text
                style={[
                  S.tableCell,
                  { width: "18%", backgroundColor: C.purpleLight, fontSize: 9 },
                ]}
              >
                {m.pct}
              </Text>
              <Text style={[S.tableCell, { width: "36%", fontSize: 9 }]}>{m.trigger}</Text>
            </View>
          ))}
        </View>
        <Text style={[S.para, { fontStyle: "italic", fontSize: 9 }]}>
          Domain, hosting, and SSL are billed directly to {companyName}. All
          recurring/third-party costs disclosed before engagement.
        </Text>

        <UnderHeading text="Our Development Approach" />
        <Text style={S.para}>
          Zithas Technologies follows a four-phase delivery methodology proven
          across 12+ years:
        </Text>
        <View style={S.table}>
          {[
            {
              label: "STRATEGY",
              desc: "Requirement analysis, scope definition, project concept & information architecture",
            },
            {
              label: "PLANNING",
              desc: "Design system, functional specs, client approval",
            },
            {
              label: "BUILD",
              desc: "Front-end & back-end development, content integration, QA & testing",
            },
            { label: "DEPLOY", desc: "Production deployment, SSL config" },
          ].map((item, i) => (
            <View
              key={i}
              style={[
                S.tableRow,
                i === 0 && { borderTopWidth: 0 },
                i % 2 !== 0 && S.tableRowAlt,
              ]}
            >
              <Text
                style={[
                  S.tableCellBold,
                  {
                    width: "25%",
                    backgroundColor: i % 2 === 0 ? C.navy : "#d8d8f0",
                    color: i % 2 === 0 ? C.white : C.navy,
                  },
                ]}
              >
                {item.label}
              </Text>
              <Text style={[S.tableCell, { flex: 1, fontSize: 9 }]}>{item.desc}</Text>
            </View>
          ))}
        </View>

        <Footer
          email={providerEmail}
          website={providerWebsite}
          phone={providerPhone}
        />
      </Page>

      {/* PAGE 5 — ABOUT ZITHAS */}
      <Page size="A4" style={S.page}>
        <TopBar location={loaction} />
        <DarkHeading2 text="ABOUT ZITHAS TECHNOLOGIES" />
        <Text style={S.para}>
          Zithas Technologies is an IT service company with a team of dedicated
          experts across web design, CRM development, ERP development, and
          full-stack web solutions. With over 12 years of industry experience,
          we have helped businesses and organizations across India and beyond
          build powerful digital platforms that drive real results.
        </Text>
        <View style={S.statsRow}>
          {[
            ["12+", "Years of Experience"],
            ["200+", "Projects Delivered"],
            ["50+", "Happy Clients"],
          ].map(([num, label], i) => (
            <View key={i} style={S.statBox}>
              <Text style={S.statNum}>{num}</Text>
              <Text style={S.statLabel}>{label}</Text>
            </View>
          ))}
        </View>
        <UnderHeading text="Our Vision" />
        <Text style={[S.para, { fontStyle: "italic" }]}>
          "Our Vision is our Inspiration. Assured quality and effective
          communication are the pillars we abide by."
        </Text>
        <UnderHeading text="From the Founder's Desk" />
        <Text style={S.para}>
          Being the founders, the sole purpose under which we work is keeping
          our clients happy and helping their business flourish. We run with the
          motto "You Grow We Grow" and make sure that we align with our clients'
          expectations.
        </Text>
        <Text style={S.para}>
          For us, Zithas is not just business — it is an opportunity to learn,
          to develop, and to achieve. It keeps us motivated and inspires us to
          reach the top and be the best.
        </Text>
        <Text style={S.para}>
          Understanding what our clients want and offering them what they expect
          is the overriding purpose of our company. We develop and implement
          optimized strategies to provide more business opportunities and
          actively help grow our clients' businesses.
        </Text>
        <View style={[S.founderBox, {backgroundColor: C.blueLight}]}>
          <Text style={[S.founderName, {fontSize: 11.5, fontFamily: "Helvetica-Bold",}]}>Julius Gohil</Text>
          <Text style={[S.founderTitle, {fontSize: 10, fontFamily: "Helvetica-Oblique"}]}>
            Founder & Director, Zithas Technologies Pvt. Ltd.
          </Text>
          <Text style={S.founderQuote}>
            "We don't just build - we build digital futures for the
            organizations we believe in."
          </Text>
        </View>
        <Footer
          email={providerEmail}
          website={providerWebsite}
          phone={providerPhone}
        />
      </Page>

      {/* PAGE 6 — WHY CHOOSE ZITHAS */}
      <Page size="A4" style={S.page}>
        <TopBar location={loaction} />
        <DarkHeading text="WHY CHOOSE ZITHAS TECHNOLOGIES?" />
        <Text style={S.para}>
          Choosing the right digital partner shapes your organization's
          credibility and reach for years to come. Here is why Zithas
          Technologies is the right choice for {companyName}:
        </Text>
        <View style={S.table}>
          <View style={[S.tableHeaderRow, { backgroundColor: C.purple }]}>
            <Text style={[S.tableHeaderCell, { width: "6%" }]}></Text>
            <Text style={[S.tableHeaderCell, { width: "34%" }]}>Strength</Text>
            <Text style={[S.tableHeaderCell, { flex: 1 }]}>
              What It Means for {companyName}
            </Text>
          </View>
          {strengths.map((s, i) => (
            <View key={i} style={[S.tableRow]}>
              <Text
                style={[
                  S.tableCell,
                  { width: "6%", backgroundColor: C.purpleLight, fontSize: 9 },
                ]}
              >
                {s.num}
              </Text>
              <Text
                style={[
                  S.tableCell,
                  { width: "34%", color: C.navy, fontWeight: "bold", backgroundColor: C.blueLight, fontSize: 9 },
                ]}
              >
                {s.title}
              </Text>
              <Text style={[S.tableCell, { flex: 1, fontSize: 9 }]}>{s.desc}</Text>
            </View>
          ))}
        </View>
        <Footer
          email={providerEmail}
          website={providerWebsite}
          phone={providerPhone}
        />
      </Page>

      {/* PAGE 7 — THANK YOU */}
      <Page size="A4" style={S.page}>
        <TopBar location={loaction} />
        <Text style={S.tyTitle}>Thank You</Text>
        <Text style={[S.tySub, {fontFamily: "Helvetica-Oblique"}]}>
          for the opportunity to present this proposal
        </Text>
        <View style={S.coverDivider} />
        <Text style={[S.para, { textAlign: "center", fontFamily: "Helvetica-Oblique", fontSize: 11 }]}>
          We look forward to partnering with {companyName} to build a
          world-class digital{"\n"}
          platform that amplifies your mission, deepens stakeholder trust, and
          drives lasting impact.
        </Text>
        <View style={S.tyContactRow}>
          <View style={[S.tyContactBox, { backgroundColor: C.blueLight, alignItems: "center" },]}>
            <Text
              style={{
                color: C.navy,
                fontSize: 9,
                fontFamily: "Helvetica-Bold",
                lineHeight: 1.5
              }}
            >
              Submit Proposal To
            </Text>
            <Text
              style={[
                S.tyContactValue,
                { fontSize: 10 },
              ]}
            >
              {proposalData?.contactname || ""}
            </Text>
            <Text
              style={[S.tyContactValue, { color: C.purple, lineHeight: 1.2, fontSize: 9 }]}
            >
              {proposalData?.email || ""}
            </Text>
          </View>

          <View
            style={[
              S.tyContactBox,
              { backgroundColor: C.purpleLight, alignItems: "center" },
            ]}
          >
            <Text
              style={[
                S.tyContactLabel,
                { color: C.purple, fontSize: 9, fontFamily: "Helvetica-Bold" },
              ]}
            >
              Our Contact
            </Text>
            <Text style={[S.tyContactValue, { fontSize: 10 }]}>
              {proposalData?.contactmember || ""}
            </Text>
            <Text style={[S.tyContactValue, { color: C.purple, fontSize: 9 }]}>
              {providerEmail}
            </Text>
            <Text style={[S.tyContactValue, { fontSize: 9 }]}>
              {providerPhone} | {providerWebsite}
            </Text>
          </View>
        </View>
        <View style={S.tyStamp}>
          <ColorBar />
          <Text style={[S.tyStampName, { fontFamily: "Helvetica-Bold", fontSize: 12 }]}>
            {loaction == 1
              ? "ZITHAS TECHNOLOGIES PVT. LTD."
              : "ZITHAS TECHNOLOGIES LTD."}
          </Text>
          <Text style={[S.tyStampSub, {fontFamily: "Helvetica-Oblique", color: C.purple, fontSize: 10}]}>
            {loaction == 1 ? "Vadodara, Gujarat, India" : "United Kingdom"} |{" "}
            {providerWebsite} | "You Grow We Grow"
          </Text>
        </View>
        <Footer
          email={providerEmail}
          website={providerWebsite}
          phone={providerPhone}
        />
      </Page>
    </Document>
  );
};

const ProposalPdf = ({ proposal_id }) => {
  const [viewData, setViewData] = useState(false);
  const [proposalData, setProposalData] = useState({});
  const [loaction, setLocation] = useState("");
  const [loading, setLoading] = useState(false);
  const [allEmails, setAllEmails] = useState([]);
  const [rfpData, setRfpData] = useState(null);

  const FetchProposalData = async () => {
    setLoading(true);
    const formData = new FormData();
    formData.append("proposal_id", proposal_id);
    try {
      const response = await axios({
        method: "post",
        url: `${configure.nodeApi}/view_proposal`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      });
      const d = response.data.data[0];
      setProposalData(d);
      setLocation(d.location);

      if (d.related === "lead" && d.source_name && d.source_name !== "null") {
        try {
          const rfpRes = await axios.get(
            `${configure.nodeApi}/get_rfp_by_lead/${d.source_name}`,
            { headers: { Accept: "application/json" } },
          );
          if (rfpRes.data.success && rfpRes.data.data) {
            setRfpData(rfpRes.data.data);
          }
        } catch (err) {
          console.error("Failed to fetch RFP data:", err);
        }
      }

      const emails = new Set();
      if (d.provideremail) emails.add(d.provideremail);
      if (d.related === "lead" && d.source_name && d.source_name !== "null") {
        try {
          const leadRes = await axios.get(
            `${configure.nodeApi}/lead_emails?lead_id=${d.source_name}`,
            { headers: { Accept: "application/json" } },
          );
          if (leadRes.data.success && Array.isArray(leadRes.data.data)) {
            leadRes.data.data.forEach((email) => {
              if (email) emails.add(email);
            });
          }
        } catch (err) {
          console.error("Failed to fetch lead emails:", err);
        }
      } else {
        if (d.email) emails.add(d.email);
      }
      setAllEmails([...emails]);
      setViewData(true);
    } catch (err) {
      console.error("FetchProposalData error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <Loader />}
      <button
        className="btn btn-sm btn-outline-secondary me-1"
        onClick={FetchProposalData}
        title="View Proposal PDF"
      >
        <i className="fa fa-file-pdf"></i>
      </button>
      <Modal size="xl" centered isOpen={viewData} className="modal-fullscreen">
        <div className="modal-header">
          <h5 className="modal-title mt-0">Proposal Preview</h5>
          <div className="d-flex align-items-center ms-auto gap-2">
            <GenerateEmailModal
    proposalData={proposalData}
    rfpData={rfpData}
    allEmails={allEmails}
  />
            {/* <button
              className="btn btn-sm btn-outline-primary"
              title="Send via Outlook"
              onClick={() => {
                const to = encodeURIComponent(allEmails.join(";"));
                const subject = encodeURIComponent(
                  proposalData?.proposaltitile || "Proposal",
                );
                window.open(
                  `https://outlook.cloud.microsoft/mail/deeplink/compose?to=${to}&subject=${subject}`,
                  "_blank",
                );
              }}
            >
              <i className="fa fa-envelope me-1"></i> Send Email
              {allEmails.length > 0 && (
                <span className="badge bg-secondary ms-1">
                  {allEmails.length}
                </span>
              )}
            </button> */}
            <button
              type="button"
              onClick={() => setViewData(false)}
              className="btn-modal-close"
              style={{ marginTop: "8px" }}
            >
              <span aria-hidden="true" className="btn-modal-span">
                &times;
              </span>
            </button>
          </div>
        </div>
        <div className="modal-body p-0">
          <PDFViewer width="100%" height="860px" style={{ border: "none" }}>
            <MyProposalDocument
              loaction={loaction}
              proposalData={proposalData}
              rfpData={rfpData}
            />
          </PDFViewer>
        </div>
      </Modal>
    </>
  );
};

export default ProposalPdf;
export { MyProposalDocument };
